const jp = {
  marketplaceDependent: {
    form: {
      targeting_link:
        "/academy/blog/targeting/hedefleme-nasil-yapilir-hedefleme-turleri-nelerdir",
      bid_link:
        "/academy/blog/management/teklif-nasil-belirlenir-teklif-turleri-nelerdir",
      frequency_link:
        "/academy/blog/measuring/gonderim-turu-nedir-zamanlanmis-rapor-nasil-olusturulur",
      report_type_link: "/academy/blog/measuring/ozel-rapor-nasil-olusturulur",
      product_link:
        "/academy/blog/optimization/urun-secimi-yaparken-nelere-dikkat-edilmeli",
    },
    campaign_form_targeting_text:
      "キャンペーンのターゲティング戦略を設定できます。",
    campaign_form_budget_text:
      "キャンペーンの予算タイプを選択し、予算を設定します。支出が予算に達すると、キャンペーンは自動的に停止します。",
    campaign_form_creative_text:
      "キャンペーンで使用するクリエイティブをアップロードできます。",
    invoice_modal_help_text:
      "［支払い方法を選択］ボタンをクリックして続行すると、支払われた金額が返金されないことに同意したものとみなされます。",
    invoice_general_error_modal_title: "残高を追加できませんでした。",
    invoice_general_error_modal_text: "エラーが発生しました。",
    invoice_unknown_error_modal_text: "予期しないエラーが発生しました。",
    invoice_product_id_error_modal_text: "製品IDのフィールドが必須です。",
    invoice_signature_error_modal_text: "署名を検証できませんでした。",
    invoice_transaction_error_modal_text: "取引IDはすでに取得されています。",
    invoice_store_error_modal_text:
      "この店舗は、指定された会社に属していません。",
    invoice_balance_error_modal_text: "店舗の残高が不足しています。",
    invoice_error_modal_title: "残高を追加できませんでした。",
    invoice_error_modal_text: "エラーが発生しました。",
  },
  marketplaceDependentTable: {
    CPC: "CPC",
    CPM: "CPM",
    RoAS: "ROAS",
  },
  marketplaceDependentSettings: {
    api_link: "https://docs.gowit.com/reference/getting-started-1",
    auto_impression_link: "https://docs.gowit.com/reference/sendevent",
    auction_link:
      "https://docs.gowit.com/docs/what-type-of-auctions-are-offered",
    product_link: "https://docs.gowit.com/docs/filters#what-is-a-product-rate",
    stock_link: "https://docs.gowit.com/docs/filters#what-is-a-product-stock",
    targeting_link:
      "https://docs.gowit.com/docs/filters#what-is-a-demographic-targeting-feature",
    bidding_link: "https://docs.gowit.com/docs/bidding-types",
  },
  sider: {
    user: {
      campaign: "キャンペーン",
      report: "レポート",
      campaigns: "キャンペーン",
      reports: "レポート",
      invoices: "請求書",
      academy: "アカデミー",
      offsiteCampaigns: "オフサイトキャンペーン",
    },
    admin: {
      campaign: "キャンペーン",
      advertisers: "広告主",
      agencies: "代理店",
      invoices: "請求書",
      finance: "財務管理",
      transactions: "取引",
      coupons: "クーポン",
      access: "アクセス",
      users: "ユーザー",
      invited: "招待済み",
      synchronization: "同期履歴",
      activity: "活動履歴",
      report: "レポート",
      settings: "設定",
      general: "一般情報",
      integration: "統合情報",
      advertiser: "広告主設定",
      auction: "オークション設定",
      single: "キャンペーン設定",
      campaigns: "キャンペーン",
      reports: "レポート",
      admin_report: "レポート",
      ad: "広告",
      placement: "広告配信面",
      creatives: "クリエイティブ",
      review: "広告レビュー",
      restrictions: "制限設定",
      console: "データソース",
      dev: "Dev. Tools",
      auctions: "オークション",
      offsite: "オフサイト設定",
      offsiteCampaigns: "オフサイトキャンペーン",
      insights: "インサイト",
    },
  },
  components: {
    adminBar: {
      rn: "現在表示しているのは、",
      visible: "広告主の画面です。",
      back: "管理者ビューに戻る",
    },
    advertiserSelect: {
      placeholder: "広告主を選択",
    },
    articles: {
      date: "キャンペーンの開始日と終了日は？",
      budget: "予算とは？予算を選ぶ際に考慮すべきことは？",
      bid: "入札と入札の種類は？",
      targeting:
        "ターゲティングの種類と正しいオーディエンスのターゲティング方法は？",
      frequency: "レポートの配信タイプとは？",
      type: "カスタムレポートの作成方法は？",
      product: "製品を選ぶ際に考慮すべきことは？",
      store: "店舗を選ぶ際に考慮すべきことは？",
    },
    breadcrumb: {
      finance: "取引",
      settings: "一般情報",
      access: "ユーザー",
    },
    bulkUpdate: {
      list: "選択したものをリスト",
      archive: "選択したものをアーカイブ",
      pause: "選択したものを一時停止",
      activate: "選択したものをアクティブ化",
      selected: "{{value}} 単位を選択済み",
      bid: "選択した入札額を編集",
      bidLabel: "入札",
      bidHelp: "選択した行の入札額が更新されます。",
      row: "{{value}} 行",
      count: "選択：",
      updateAllBids: "入札額を編集",
      updateAllBidsText:
        "テーブルに表示されているすべての行の入札額を編集できます。",
      updatingAllBids: "すべての行の入札額を編集しています。",
      updateAllBidsHelp:
        "テーブルに表示されているすべての行の入札額が更新されます。",
    },
    datasource: {
      entity: "あなたのエンティティは何ですか？",
      method: "インポート方法は何ですか？",
      configurations: "設定を行ってください",
      mapping: "フィールドマッピング",
      emptyEntity: "あなたの<strong>エンティティ</strong>は何ですか？",
      emptyEntityText:
        "データを追加するエンティティの種類を選択してください。この選択によりデータの構造が定義され、インポートに必要なフィールドが決まります。エンティティには、商品や広告主などが含まれます。選択後、このエンティティに特有のデータフィールドを設定できます。",
      productEntityText:
        "商品エンティティは、個々の商品に関連するデータを表します。商品ID、名前、説明、価格、フィルター、在庫情報などのフィールドを含みます。このエンティティは、各商品の詳細情報を取得し管理するために設計されています。",
      advertiserEntityText:
        "広告主データソースは、広告主に関連するデータを表します。広告主ID、名前、ステータスなどのフィールドが含まれます。このデータタイプは、各広告主の詳細情報を取得および管理するために設計されています。",
      selectEntity: "エンティティを選択",
      selectEntityDescription:
        "データを追加するエンティティの種類を選択してください。この選択によりデータの構造が定義され、インポートに必要なフィールドが決まります。エンティティには、商品や広告主などが含まれます。選択後、このエンティティに特有のデータフィールドを設定できます。",
      product: "商品",
      productText:
        "商品エンティティは、個々の商品に関するデータを表します。商品ID、名前、説明、価格、フィルター、在庫情報などのフィールドが含まれます。このエンティティは、各商品の詳細な情報を取得し、管理するために設計されています。",
      seeFields: "{{value}} データスキーマを表示",
      how: "使用方法を見る",
      advertiser: "広告主",
      advertiserText:
        "広告主エンティティは、広告主に関連するデータを表します。広告主ID、名前、その他の関連情報が含まれます。正しい統合を確保するために、必須フィールドには 'ID' と '名前' が含まれます。このエンティティは、広告主に関する重要な情報を整理および管理するのに役立ちます。",
      soon: "近日公開",
      schema: "{{value}} データスキーマ",
      required: "必須",
      showFields: "追加フィールドを表示",
      emptyMethod: "あなたの<strong>インポート方法</strong>は何ですか？",
      emptyMethodText:
        "選択したソースからデータをインポートする方法を選択してください。選択した方法に応じて、システムはデータを正しく処理するためにインポートプロセスを自動的に適応させます。各方法にはそれぞれの利点があるため、ニーズに最も適したものを選択してください。",
      filledMethod: "インポート方法：<strong>{{value}}</strong>",
      googleFeedUrl: "Google フィード URL",
      googleFeedFile: "Google フィードファイルアップロード (XML)",
      googleFeedDirectXml: "直接 XML アップロード（リクエストボディ）",
      filledMethodText:
        "Feed URLを提供するか、サポートされている形式でファイルをアップロードして、{{value}}からデータをインポートするためにこのオプションを使用します。",
      selectMethod: "インポート方法を選択",
      googleFeedText:
        "Google Feedは、Feed URLを提供するか、サポートされている形式でファイルをアップロードして、Google Feedからデータを直接インポートするために使用されます。この機能は、商品フィード統合時に広告主の作成を自動的に管理することで、プロセスを簡素化します。",
      feedUrl: "Feed URL",
      feedUrlText: "Googleフィードデータが直接ソースから取得される特定のURL。",
      fileUpload: "ファイルアップロード (XML)",
      fileUploadText:
        "Googleフィードファイルは、XML形式を使用して手動でインポートできます。",
      requestBody: "直接XMLアップロード (リクエスト本文)",
      requestBodyText:
        "リクエストボディ内のXMLを介してGoogleフィードデータをインポートできる直接統合方法で、従来のファイルアップロードを回避します。（近日公開予定の機能）",
      configTitle: "<strong>設定</strong>を構成",
      configText:
        "データソースの基本設定を定義します。これらの設定を正しく構成することで、データインポートプロセスが円滑に進み、データがシステム内で最新の状態に保たれます。データソースを保存した後は、これらの設定を変更することはできません。",
      name: "データソース名",
      nameHelp:
        "このデータソース構成に一意の名前を入力してください。後でソースを識別するのに役立ちます。",
      url: "Feed URL",
      urlHelp:
        "フィードを取得できる完全なURLを提供してください。システムはこのリンクから定期的にデータを取得します。",
      cycle: "サイクルを選択",
      cycleHelp:
        "システムが指定されたFeed URLから更新を取得する頻度を指定します。",
      fetch: "取得＆マッピング",
      mappingTitle: "フィールド<strong>マッピング</strong>",
      mappingText:
        "このセクションでは、データソースのフィールドをシステム内の対応するフィールドにマッピングします。システムフィールドには特定の要件があり、必須フィールドは正しくマッピングされる必要があり、インポートが成功するようにする必要があります。データソースに一致するデータがない必須フィールドについては、デフォルト値を設定することを選択できます。これにより、インポートプロセス中に重要な情報が欠落しないようにすることができます。フィールドのマッピングが完了したら、すべての必須フィールドが正しくマッチングされていることを確認してから、マッピングを検証する必要があります。",
      validate: "マッピングを検証",
      system: "システムフィールド",
      imported: "インポートされたフィールド",
      preview: "プレビュー",
      hideFields: "追加フィールドを非表示",
      feedUrlLink: "Google製品データ仕様",
      upload: "XML ファイルをアップロード",
      uploaded: "ファイルがアップロードされました！",
      uploadText: "またはここにドラッグ＆ドロップ",
      metaFeedText:
        "Meta Feedは、フィードURLやファイルアップロードを含むさまざまな形式でデータのインポートをサポートします。追加の対応フォーマットおよびフィールド設定は近日中に導入される予定です。",
      metaFeedUrlText:
        "Meta Feed統合のためにデータを直接取得する専用のURLソース。",
      metaFeedUrl: "Meta Feed URL",
      xml: "直接 XML コード",
      xmlHelp:
        "データをソースからインポートするために、XMLコードを直接入力してください。",
      api: "API統合",
      apiText:
        "API統合は、指定されたAPIエンドポイントへの接続を提供し、データの同期を可能にし、システムへの情報の継続的な流れを確保します。",
      apiButtonText:
        "指定されたAPIエンドポイントに接続してデータを取得するための設定を提供します。この統合により、当社のAPIへのリクエストを通じてデータの同期が可能になり、変更が発生すると最新の情報が直接システムに流れ込みます。",
      impression: "インプレッション",
      impressionText:
        "インプレッションエンティティは、広告表示に関連するデータを表します。これには、広告ID、セッションID、その他の関連詳細が含まれます。このエンティティは、広告が画面に表示されるたびに記録することで、広告の可視性を測定するのに役立ちます。",
      click: "クリック数",
      clickText:
        "クリックエンティティは、ユーザーが広告をクリックした際のインタラクションに関連するデータをキャプチャします。フィールドには、広告ID、セッションID、およびその他の関連する詳細が含まれます。これにより、ユーザーのエンゲージメントに関する洞察を提供し、すべての広告クリックを記録することで、ユーザーの行動を詳細に分析することができます。",
      sale: "販売",
      saleText:
        "セールエンティティは、広告のインタラクションから生じたすべてのコンバージョンや購入に関するデータを含みます。正確な追跡とレポートを確保するために、すべてのセールイベントを当社に送信することが重要です。このデータにより、カテゴリバイヤー、新規顧客、既存顧客といった顧客タイプ、および直接コンバージョンと間接コンバージョンについての詳細なインサイトを提供できます。",
      productSchema: {
        id: "商品のID",
        name: "商品の名前",
        advertiser_id: "広告主のID",
        image_url: "商品の画像URL",
        description: "商品の説明",
        price: "商品の価格（複数の場所では-1を返します）",
        filters: "商品に適用されるフィルター",
        buybox: "商品にbuyboxがあるかどうかを示します",
        sub_class_names: "商品のサブクラス名",
        brand: "商品のブランド",
        retailer_taxonomy: "商品の小売業者分類",
        google_taxonomy: "商品のGoogle分類",
        product_type: "商品の種類",
        global_identifier: "商品のグローバル識別子",
        global_identifier_type: "グローバル識別子の種類（GTINまたはASIN）",
        rating: "商品の評価",
        stock: "商品の在庫（複数の場所では-1を返します）",
        sku: "商品のSKU",
        barcode: "商品のバーコード",
        price_range: "商品の価格帯",
        status: "商品の状態",
        retailer_taxonomy_id_structure: "小売業者分類ID構造",
        process_id: "プロセスID",
      },
      advertiserSchema: {
        id: "広告主のID",
        name: "広告主の名前",
        time_zone: "広告主のタイムゾーン",
        email: "広告主のメールアドレス",
        language: "広告主の言語",
        status: "広告主のステータス",
        process_id: "広告主のプロセスID",
      },
    },
    download: {
      campaigns: "キャンペーン",
      advertisers: "広告主",
      agencies: "代理店",
      transactions: "取引",
      coupons: "クーポン",
      users: "ユーザー",
      sync_logs: "同期ログ",
      reports: "レポート",
      query: "パフォーマンスレポート",
      PRODUCTS: "製品",
      KEYWORDS: "キーワード",
      NEGATIVE_KEYWORDS: "ネガティブキーワード",
      AGE_RANGES: "年齢",
      CITIES: "都市",
      PLATFORMS: "プラットフォーム",
      GENDERS: "性別",
      PLACEMENTS: "広告配信面",
      CUSTOMERS: "顧客",
      CATEGORIES: "カテゴリー",
      NEGATIVE_CATEGORIES: "ネガティブカテゴリー",
      CREATIVES: "クリエイティブ",
    },
    inbox: {
      title: "受信箱",
      empty: "通知はありません。",
      unread: "未読のみ",
      default: "すべて",
      archived: "アーカイブ済み",
      readAll: "すべてを既読としてマーク",
      archiveAll: "すべてをアーカイブ",
      archiveRead: "既読をアーカイブ",
      preferences: "通知の設定",
      global: "全体の設定",
      balance: "残高不足",
      categories: "低い入札額（カテゴリ）",
      keywords: "低い入札額（キーワード）",
      products: "製品が停止されました",
      creative: "拒否されたクリエイティブ",
      review: "クリエイティブが作成されました",
    },
    info: {
      firstTipCreate:
        "推奨設定を選ぶことで、簡単に効果的なキャンペーンを作成できます。推奨設定は広告のパフォーマンスを最適化します。",
      secondTipCreate:
        "キャンペーンのパフォーマンスを向上させるために、十分な在庫があり、高評価で、Buy Boxを獲得した製品を選択することができます。",
      thirdTipCreate:
        "広告予算を増やすことで、製品の視認性を向上させ、クリック数と売上を伸ばすことができます。",
      forthTipCreate:
        "キャンペーンで高額入札を設定することで、製品がより目立つ位置に表示されるようになります。",
      survey: "簡単なアンケートにご回答いただき、改善にご協力ください。",
    },
    invite: {
      selected: "{{value}} 単位を選択済み",
      invite: "選択した人を招待",
      reinvite: "選択した人を再招待",
    },
    modal: {
      campaign: {
        create: "新しいキャンペーンを作成",
        success: "キャンペーンが作成されました",
        successText:
          "［OK］ボタンをクリックすると、キャンペーンの詳細ページに進むことができます。",
      },
      campaignDetails: {
        products: "製品の選択",
        keywords: "キーワードを追加",
        update: "キャンペーンを更新",
        negative_keywords: "ネガティブキーワードを追加",
        products_btn: "製品を追加",
        keywords_btn: "キーワードを追加",
        negative_keywords_btn: "ネガティブキーワードを追加",
        update_btn: "更新",
        create_agency: "新しい代理店を追加",
        update_agency: "代理店を更新",
        create_agency_btn: "追加",
        update_agency_btn: "更新",
        create_user: "新しいユーザーを追加",
        create_user_marketplace: "管理ユーザーを追加",
        create_user_marketplace_btn: "追加",
        create_user_advertiser: "広告主ユーザーを追加",
        create_user_advertiser_btn: "追加",
        select_advertiser: "広告主を選択",
        select_advertiser_btn: "続行",
        update_advertiser: "広告主を更新",
        update_advertiser_btn: "更新",
        invoice: "残高を追加",
        invoice_btn: "支払い方法を選択",
        coupons: "クーポンを設定",
        coupons_btn: "クーポンを設定",
        transactions: "残高を追加",
        transactions_btn: "残高を追加",
        categories: "新しいカテゴリーを追加",
        categories_btn: "カテゴリーを追加",
        negative_categories: "ネガティブカテゴリーを追加",
        negative_categories_btn: "カテゴリーを追加",
        transaction_details: "取引の詳細",
        settings: "変更内容を保存",
        settings_btn: "保存",
        creatives: "クリエイティブを追加",
        creatives_btn: "クリエイティブを追加",
        approve_balance: "残高を追加",
        approve_balance_btn: "取引を確認",
        approve_coupon: "クーポンを追加",
        approve_coupon_btn: "クーポンを確認",
        payment_options: "残高を追加",
        payment_options_btn: "読み込み",
        add_user: "新しいユーザーを招待",
        add_user_btn: "招待状を送信",
        targeting_settings: "広告主の選択",
        targeting_settings_btn: "選択",
        update_transaction: "請求書番号を編集",
        update_transaction_btn: "保存",
        select_user: "ユーザータイプを選択",
        select_user_btn: "続行",
        select_language: "言語を変更",
        select_language_btn: "変更",
        campaign_form: "キャンペーン概要",
        campaign_form_btn: "キャンペーンを作成",
        update_bid: "入札額を編集",
        update_bid_btn: "編集",
        update_dayparting: "時間帯指定",
        update_dayparting_btn: "更新",
        reject_creative: "クリエイティブを拒否",
        reject_creative_btn: "確認",
        refund: "払い戻し",
        refund_btn: "払い戻しをリクエスト",
        confirm_refund: "払い戻しを確認",
        confirm_refund_btn: "払い戻しを確認",
        archive_confirmation: "アーカイブ確認",
        archive_confirmation_btn: "確認してアーカイブ",
        ad_summary: "広告概要",
        ad_summary_btn: "広告を作成",
        confirm_keyword_tab: "プロセスを確認",
        confirm_keyword_tab_btn: "続行してキーワードを削除",
        update_redirect_url: "リダイレクトURLを編集",
        update_redirect_url_btn: "編集",
      },
      selectCampaign: {
        title: "キャンペーンタイプを選択",
        text: "キャンペーンタイプを選択してください。",
        soon: "近日",
        sponsored_product_availability_title: "スポンサー製品",
        sponsored_product_availability_text:
          "関連キーワードを検索したり、類似製品を閲覧したりする顧客にプロモーションします。",
        sponsored_brand_availability_title: "スポンサーブランド",
        sponsored_brand_availability_text:
          "魅力的なクリエイティブを使用して、顧客にブランドや製品を見つけてもらいましょう。",
        sponsored_display_availability_title: "スポンサーディスプレイ",
        sponsored_display_availability_text:
          "オンサイトとオフサイトで関連するオーディエンスにリーチして、ビジネスを成長させます。",
        sponsored_store_availability_title: "スポンサーストア",
        sponsored_store_availability_text:
          "店舗のリーチを拡大し、買い物客があなたの店舗を見つけやすくしましょう。ターゲットを絞ったショッピング体験を提供します。",
        sponsored_video_availability_title: "スポンサービデオ",
        sponsored_video_availability_text:
          "ビデオ広告でターゲットオーディエンスにリーチし、魅力的な要素を使って売上を増やします。",
        sponsored_display_with_product_availability_title:
          "スポンサーディスプレイ（製品付き）",
        sponsored_display_with_product_availability_text:
          "サイト内外で関連する興味を持つ買い物客をターゲットにして、製品を効果的に宣伝します。",
        sponsored_video_with_product_availability_title:
          "スポンサービデオ（製品付き）",
        sponsored_video_with_product_availability_text:
          "動的で魅力的なビデオコンテンツを使用して、製品の認知度を高め、オーディエンスを引き付けます。",
        in_store_availability_title: "店舗内",
        in_store_availability_text:
          "実際に店舗を訪れている買い物客とエンゲージしましょう",
      },
      success: {
        advertisers_success_title: "招待状が送信されました",
        advertisers_success_text:
          "入力されたメールアドレスに招待状が送信されました。ユーザーは、招待リンクをクリックして、アカウントにアクセスするためのパスワードを作成する必要があります。",
        reports_success_title: "レポートが作成されました",
        reports_success_text:
          "［OK］ボタンをクリックすると、レポートの詳細ページに進むことができます。",
        invited_success_title: "ユーザーが招待されました",
        invited_success_text:
          "ユーザーがリストに表示されるためには、招待メールをクリックしてパスワードを作成する必要があります。",
        agencies_success_title: "代理店が作成されました",
        agencies_success_text: "nan",
        multiple_advertisers_success_title: "招待状が送信されました",
        multiple_advertisers_success_text: "選択された広告主が招待されました。",
        invoice_success_title: "残高を追加しました。",
        invoice_success_text:
          "残高が追加されました。新しいキャンペーンを作成できます。",
        create_advertiser_success_title: "広告主を追加しました。",
        create_advertiser_success_text:
          "広告主を有効にするには、招待する必要があります。",
        payment_success_title: "残高の追加リクエストを受け付けました。",
        payment_success_text:
          "送金またはEFT支払いが承認されると、アカウントに転送されます。承認プロセスには2〜3営業日かかります。",
        craftgate_success_title: "残高の追加リクエストを受け付けました。",
        craftgate_success_text: "残高が迅速にアカウントに転送されます。",
        file_success_title: "ファイルが正常にアップロードされました！",
        file_success_text:
          "ファイルが正常にアップロードされ、処理されました。次のステップに進むことができます。",
        xml_success_title: "XML が正常に処理されました！",
        xml_success_text:
          "XML データが正常に処理されました。次のステップに進むことができます。",
      },
      error: {
        craftgate_title: "残高が追加されませんでした。",
        craftgate_text: "クレジットカードでの残高追加に失敗しました。",
        file_title: "XML ファイルアップロードエラー",
        file_text:
          "XML ファイルの処理中に問題が発生しました。ファイル形式が正しく、必要な構造に合っていることを確認してください。問題が解決しない場合は、サポートに連絡して追加の支援を受けてください。",
        xml_title: "XML 処理エラー",
        xml_text:
          "XML データの処理中に問題が発生しました。XML の構造と内容が正しいことを確認してください。問題が解決しない場合は、サポートに連絡して追加の支援を受けてください。",
      },
      warning: {
        campaign_warning_title: "このページを離れてもよろしいですか？",
        campaign_warning_text: "変更は保存されません！",
      },
    },
    navbar: {
      search: "入力して検索...",
      help: "ヘルプ＆サポート",
      site: "販売者パネルに戻る",
    },
    navbarPopover: {
      account: "アカウントを変更",
      language: "言語を変更",
      logout: "ログアウト",
    },
    notification: {
      formTitle: "フォームが完了していません。",
      formText: "空欄と必須フィールドに入力してください。",
      paused: "{{value}} を停止しました。",
      active: "{{value}} を有効化しました。",
      campaigns: "キャンペーン",
      reports: "レポート",
      products: "製品",
      keywords: "キーワード",
      negative_keywords: "ネガティブキーワード",
      categories: "カテゴリー",
      negative_categories: "ネガティブカテゴリー",
      placements: "広告配信面",
      users: "ユーザー",
      advertisers: "広告主",
      agencies: "代理店",
      ad_placements: "広告配信面",
      creatives: "クリエイティブ",
      account_users: "ユーザー",
      statusError: "エラーが発生しました。",
      activeReport: "レポートをアーカイブしました。",
      archivedReport: "レポートのアーカイブを解除しました。",
      activeCampaign: "キャンペーンをアーカイブしました。",
      pausedCampaign: "キャンペーンをアーカイブしました。",
      archivedCampaign: "キャンペーンのアーカイブを解除しました。",
      activeAgency: "代理店をアーカイブしました。",
      archivedAgency: "代理店のアーカイブを解除しました。",
      invitedAdvertiser: "広告主をアーカイブしました。",
      activeAdvertiser: "広告主のアーカイブを解除しました。",
      archivedAdvertiser: "広告主をアーカイブしました。",
      archived_ad_placement: "広告配置のアーカイブが成功しました。",
      archived_reports_bulk: "レポートをアーカイブしました。",
      archived_campaigns_bulk: "キャンペーンをアーカイブしました。",
      archived_users_bulk: "ユーザーをアーカイブしました。",
      archived_advertisers_bulk: "広告主をアーカイブしました。",
      archived_agencies_bulk: "代理店をアーカイブしました。",
      archived_account_users_bulk: "ユーザーをアーカイブしました。",
      keyword: "少なくとも1つのキーワードを追加してください。",
      category: "少なくとも1つのカテゴリーを追加してください。",
      invite: "{{value}} 件の招待状が送信されました。",
      full_invite: "すべての招待状が送信されました。",
      rejected: "クリエイティブの拒否が完了しました。",
      accepted: "クリエイティブの検証が完了しました。",
      uninvitedAdvertiser: "広告主を有効にしました。",
      settings_success: "設定が保存されました。",
      previous_invite_sent_too_recently:
        "{{value}} 件の招待状が最近送信されました。しばらくたってから再度お試しください。",
      user_email_is_already_registered:
        "{{value}} 件のメールアドレスはすでに登録されています。",
      copiedCampaign: "キャンペーンをコピーしました。",
      copyError: "キャンペーンをコピー中にエラーが発生しました。",
      editableFieldError:
        "最小値を超える値を入力してください。超えない場合は、自動的に調整されます。",
      active_account_user: "ユーザーをアーカイブしました。",
      archived_account_user: "ユーザーのアーカイブを解除しました。",
      bid: "{{value}} 行の入札額が更新されました。",
      advertiserBalanceLowSubject: "残高が不足しています！",
      advertiserBalanceLowBody:
        "広告主の残高が危険なレベルにまで減少しています。広告を中断なく配信するために、今すぐチャージしてください。",
      campaignKeywordsBelowMinBidSubject:
        "キャンペーン #{{value}} 内のキーワードの入札額が低すぎます",
      campaignKeywordsBelowMinBidBody:
        "キャンペーン (ID: {{value}}) 内のすべてのキーワードの入札額が、マーケットプレイスの最低入札要件を下回っています。入札額を更新して可視性を向上させましょう。",
      campaignCategoriesBelowMinBidSubject:
        "キャンペーン #{{value}} 内のカテゴリの入札額が低すぎます",
      campaignCategoriesBelowMinBidBody:
        "キャンペーン (ID: {{value}}) 内のすべてのカテゴリの入札額が、最低入札要件を下回っています。入札額を更新して可視性を向上させましょう。",
      campaignProductsStoppedSubject:
        "キャンペーン #{{value}} 内の製品が非アクティブになっています",
      campaignProductsStoppedBody:
        "キャンペーン (ID: {{value}}) 内の製品が一時停止されています。キャンペーンを効果的に継続するために、新しい製品を追加することを検討してください。",
      creativeRejectedSubject:
        "キャンペーン #{{value}} のクリエイティブが拒否されました",
      creativeRejectedBody:
        "キャンペーン (ID: {{value}}) 内のクリエイティブが拒否されました。フィードバックを確認し、プラットフォームのガイドラインに従ってクリエイティブを更新してください。",
      marketplaceAdvertiserBalanceLowSubject:
        "{{value}} の予算が不足しています",
      marketplaceAdvertiserBalanceLowBody:
        "{{value}} の残高が危険なレベルにまで減少しています。広告を中断なく配信するために、今すぐチャージしてください。",
      creativeCreatedSubject:
        "{{value}} が新しいクリエイティブを追加しました。",
      creativeCreatedBody:
        "{{value}} は新しいクリエイティブを作成しました。マーケットプレイスダッシュボードでこのクリエイティブを確認して承認できます。",
      newBid: "新しい「入札」：{{value}}。",
      balanceAction: "残高をチャージ",
      productAction: "新しい製品を追加",
      bidAction: "入札額を更新",
      creativeAction: "クリエイティブを更新",
      reviewAction: "確認",
      segments: "セグメント",
    },
    suggestedTag: {
      text: "おすすめ",
    },
    campaignCard: {
      graph: "グラフに表示",
      hide: "非表示",
      message: "{{value}} 日間",
    },
    campaignForm: {
      firstStep: {
        keywordStepTitle: "キーワード情報",
        categoryStepTitle: "カテゴリー情報",
        targetingStepTitle: "オーディエンス情報",
        campaignInfoTitle: "キャンペーン情報",
        campaignInfoText:
          "キャンペーンテーブルに表示される名前を入力してください。この名前は顧客には表示されません。宣伝したい製品に関連する名前を選ぶことをお勧めします。",
        campaignLabel: "キャンペーン名",
        campaignSub: "キャンペーン名を入力します。",
        dateInfoTitle: "キャンペーン日付",
        dateInfoText: "キャンペーンの期間を設定します。",
        startDateLabel: "開始日",
        startDateSub: "キャンペーンの開始日を選択します。",
        stopped: "継続",
        stoppedText: "キャンペーンは今日開始し、停止するまで続行されます。",
        stoppedSub: "開始「日」：{{value}}",
        defined: "開始日 - 終了日",
        definedText: "キャンペーンが実行される期間を選択できます。",
        budget: "予算",
        totalBudget: "総予算の制限",
        totalBudgetLabel: "総予算",
        dailyBudgetLabel: "1日の予算",
        dailyBudgetExtra:
          "キャンペーンの1日の費用は、指定した最大金額になります。",
        dailyBudgetFilter: "1日の予算",
        dailyBudgetText: "1日の予算を設定できます。",
        totalBudgetExtra:
          "キャンペーンでは、毎日指定した最大金額が消費されます。",
        flexibleBudgetLabel: "1日の予算",
        totalBudgetFilter: "総予算",
        totalBudgetText: "総予算を設定できます。",
        bid: "入札",
        bidText:
          "キャンペーンの入札タイプを設定します。広告費用は、選択した入札タイプに基づいてクリックごとに発生します。",
        dynamicBid: "自動入札",
        dynamicBidText: "クリックあたりの費用は、自動的に決定されます。",
        targetAcosTitle: "ターゲットACoS",
        targetAcosText:
          "広告からの売上のどれくらいを広告費として使用するかを選択します。",
        default: "デフォルト",
        advanced: "詳細設定",
        fixedBid: "固定入札",
        fixedBidText:
          "キーワードおよびカテゴリーごとに固定のクリック単価を設定します。キャンペーンは、顧客のターゲティング設定に基づいて表示されます。",
        productTitle: "製品の選択",
        productText: "広告を出したい製品を選択します。",
        acosTooltip:
          "ACoSは、広告費用対売上を意味します。これは、売上に対してどれだけの金額を広告に費やすかを示す比率です。例えば、ACoSが10%のキャンペーンでは、10円の売上に対して1円を広告に使うことになります。",
        autoTargeting: "自動ターゲティング",
        autoTargetingText:
          "キャンペーンに最適なキーワードまたはカテゴリーがターゲットになります。",
        manualTargeting: "手動ターゲティング",
        manualTargetingText:
          "キャンペーンを表示するキーワードまたはカテゴリーを設定できます。",
        suggestedBidText: "推奨「入札額」：",
        acosError: "ACoSは、0.0001〜100の範囲である必要があります。",
        creativeTitle: "クリエイティブの情報",
        videoText:
          "キャンペーンで使用するクリエイティブをアップロードできます。",
        urlTitle: "リダイレクトURL",
        urlText:
          "広告をクリックしたユーザーが誘導されるページです。ユーザーをマーケットプレイス内のページにリダイレクトする必要があります。",
        displayDraggerTitle:
          "<strong>画像をドラッグ＆ドロップ、または </strong> <0>参照</0>",
        creativeLabel: "クリエイティブ名",
        size: "サイズ：",
        listWarningSize: "5120KB(5MB)",
        listWarningType: "JPG, PNG, GIF",
        recommendedSizes: "推奨サイズ",
        allSizeText: "プラットフォーム上のすべてのサイズを表示するには",
        visit: "訪問",
        allowedFileTypes: "許可されているファイル形式:",
        maximumFileSize: "最大ファイルサイズ:",
        modalTitle: "クリエイティブの次元",
        modalText:
          "リストにあるすべてのサイズのクリエイティブをアップロードできます。推奨サイズでクリエイティブをアップロードすると、広告のパフォーマンスが向上します。",
        recommended: "推奨サイズ",
        accepted: "対応可能サイズ",
        creativeError: "クリエイティブ名を入力してください。",
        urlError: "URLを入力してください。",
        budgetError: "予算は{{value}}以上である必要があります。",
        budgetErrorMessage: "予算を入力してください。",
        invalid: "無効なサイズ",
        advancedOptions: "詳細オプション",
        placements: "広告配信面",
        placementsText: "広告を表示する領域を指定します。",
        in_search: "検索結果",
        in_search_text: "広告は関連する検索結果に表示されます。",
        in_product_detail_page: "製品詳細ページ",
        in_product_detail_page_text:
          "広告は関連する製品詳細のページに表示されます。",
        in_category: "カテゴリー",
        in_category_text: "広告は関連するカテゴリーのページに表示されます。",
        in_home_page: "ホームページ",
        in_home_page_text: "広告はホームページに表示されます。",
        in_collection: "コレクション",
        in_collection_text:
          "広告は関連するコレクションのページに表示されます。",
        storeTitle: "店舗選択",
        storeText: "広告を出したい店舗を選択します。",
        info: "一般情報",
        advertiser: "広告主「名」：",
        budgetType: "予算「タイプ」：",
        bidType: "入札「タイプ」：",
        standart: "自動入札",
        fixed: "固定入札",
        max_acos: "ターゲットACoS",
        fixed_info: "入札：",
        max_acos_info: "ACoS：",
        targeting: "ターゲティング",
        custom: "カスタム",
        durationText:
          "キャンペーンが毎日の日次予算ターゲットに達すると、<strong>{{value}}日間</strong>アクティブな状態を維持します。",
        dayParting: "時間帯指定",
        dayPartingText: "キャンペーンを有効にする日と時間を設定します。",
        allTimes: "すべての時間帯",
        allTimesText: "キャンペーンは一日中、全時間帯で有効です。",
        scheduled: "日付範囲を選択",
        scheduledText: "キャンペーンは、指定した日と時間帯に有効になります。",
        dayPartingTableText:
          "以下の<strong>ボックス</strong>にチェックを入れて、希望する日と時間帯を選択してください。1日すべての時間帯を希望する場合は、<strong>［終日］</strong>のオプションを選択できます。",
        allDay: "終日",
        clear: "選択をクリア",
        videoSideTitle: "クリエイティブを追加",
        videoSideText:
          "クリエイティブの種類を選択し、フォーマットを決定します。",
        firstDrawerTitle: "ステップ1：クリエイティブタイプを選択",
        creativeTypeTitle: "クリエイティブタイプ",
        creativeTypeText:
          "広告に適したクリエイティブタイプを選択してください。",
        mp4Title: "動画ファイルから作成",
        mp4Text: ".MP4動画ファイルを使用してクリエイティブを作成できます。",
        vast: "VAST タグ",
        vast_drawer: "広告に表示される動画の VAST タグを追加してください。",
        vastTitle: "VASTタグを使用して作成",
        vastText:
          "データに基づくVASTタグを使用してクリエイティブを作成できます。",
        creativeLanguageTitle: "クリエイティブ言語",
        creativeLanguageText: "クリエイティブの言語を選択してください。",
        creativeLanguageSearch: "言語を検索",
        autoTargetingProductWarning:
          "自動ターゲティングを有効にするには、<strong>関連商品</strong>ステップから少なくとも<strong>“1”</strong>つの商品を選択する必要があります。",
        connectedProductsTitle: "関連商品",
        connectedProductsText:
          "上記のクリエイティブに関連する、あなたのために特別にキュレーションされた商品。",
        showProducts: "関連商品を表示",
        showProductsText:
          "このオプションを有効にして、クリエイティブに関連する商品を追加します。関連する商品をクリエイティブに関連付けることで、広告の関連性を高めることができます。",
        promoteProduct: "商品を宣伝",
        promoteProductText:
          "この機能は、キャンペーンに追加した商品が目立つ位置に表示されるようにします。",
        promoteProductWarning:
          "一度選択すると、このオプションは変更できませんのでご注意ください。",
        closeProducts: "関連商品を閉じる",
        closeProductsText:
          "クリエイティブに関連する商品の使用を無効にすることは推奨されません。広告の関連性が低下する可能性があります。",
        spendingTitle: "支出分配",
        spendingText: "広告予算の時間配分と強度を定義します。",
        spendingSub: "支出分配を決定します。",
        asap: "できるだけ早く",
        front_loaded: "フロントローディング",
        evenly: "均等に",
        frontPercentage: "割合",
        multiRegion: "地域選択",
        multiRegionText:
          "キャンペーンは複数の地域または特定の地域で実行できます。",
        allRegions: "すべての地域",
        allRegionsText: "キャンペーンはすべての地域で公開されます。",
        selectedRegions: "選択された地域",
        selectedRegionsText: "キャンペーンは選択された地域のみで公開されます。",
        regionPlaceholder: "地域を選択してください",
        evenlyText:
          "キャンペーンは着実に進行し、すべての期間に均等に焦点が当てられています。",
        asapText:
          "予算は迅速に消費され、キャンペーン初期に早急な結果を得ます。",
        front_loadedText:
          "開始時に多くの労力が集中し、その後徐々に減少して存在感を維持します。",
        displayUploadTitle: "画像ファイルでクリエイティブを作成",
        displayUploadText:
          ".JPEG、.PNG、または .GIF ファイルを使用してクリエイティブを作成できます。",
        display_upload_second_drawer_title:
          "ステップ 2: 画像ファイルを使って追加",
        display_upload: "画像をアップロード",
        display_upload_drawer:
          "広告に表示する画像ファイルをアップロードしてください。",
        changeDisplay: "画像を変更",
        displayErrorTitle: "画像にエラーがあります！",
        displayErrorText:
          "アップロードしようとしている画像の寸法が正しくありません。",
        newDisplay: "新しい画像をアップロード",
        bulk: "一括アップロード",
        scriptUploadTitle: "スクリプトコードを使用してクリエイティブを作成",
        scriptUploadText:
          "スクリプトコードを使用してクリエイティブを作成できます。",
        script: "スクリプトコード",
        script_drawer: "広告に表示するコードを入力してください。",
        creativeSizeTitle: "広告サイズ",
        creativeSizeText: "クリエイティブの広告サイズを選択してください。",
        creativeSizeSearch: "サイズを選択",
        vast_second_drawer_title: "ステップ 2: VAST タグを使用して追加",
        script_second_drawer_title:
          "ステップ 2: スクリプトコードを使用して追加",
        video_upload_second_drawer_title:
          "ステップ 2: 動画ファイルを使用して追加",
        creativeNameTitle: "クリエイティブ名",
        creativeNameText: "クリエイティブの名前を入力してください。",
        creativeVideoLabel: "クリエイティブ名を入力してください。",
        video_upload: "動画をアップロード",
        video_upload_drawer:
          "広告に表示するために動画ファイルをアップロードしてください。",
        videoDraggerTitle:
          "<strong>動画をドラッグ＆ドロップ、または </strong> <0>参照</0>",
        maxVideoSize: "10240KB(10MB)",
        videoFormat: "MP4",
        in_store_entrance: "入口",
        in_store_register: "レジ",
        in_store_basket: "トイレ",
        in_store_shelf: "セルフレジ",
        in_store_garden: "ガーデン",
        in_store_paint: "ペイント",
        in_store_entrance_text: "店内のスクリーンに広告が表示されます。",
        in_store_register_text: "店内のスクリーンに広告が表示されます。",
        in_store_basket_text: "店内のスクリーンに広告が表示されます。",
        in_store_shelf_text: "店内のスクリーンに広告が表示されます。",
        in_store_garden_text: "店内のスクリーンに広告が表示されます。",
        in_store_paint_text: "店内のスクリーンに広告が表示されます。",
        errorStates: {
          name: "キャンペーン名を入力してください。",
          keywordErr: "キーワードは一意である必要があります。",
          advertiserErr: "広告主はアクティブではありません。",
          placementsError: "少なくとも1つの広告配信面を選択してください。",
          productLimitErr: "250製品まで追加可能です。",
          code: "コードを編集",
          preview: "プレビュー",
          sameKeyword:
            "ターゲット キーワードと除外キーワードに同じキーワードを含めることはできません。",
          duplicateKeyword:
            "キーワードはすでにキャンペーンに追加されています。",
          duplicateNegativeKeyword:
            "ネガティブキーワードはすでにキャンペーンに追加されています。",
          generalErr: "エラーが発生しました。",
          keywordLimitErr:
            "キャンペーンには最大100個のキーワードを追加できます。",
          categoryLimitErr:
            "キャンペーンには最大100個のカテゴリを追加できます。",
          frontPercentage:
            "フロントローディングされた割合は0から100の間でなければなりません。",
          creativeDimensionErr:
            "正しい寸法のクリエイティブをアップロードしてください。",
          languageErr: "言語を追加してください。",
          sizeErr: "サイズを選択してください。",
          script:
            "無効なHTMLクリエイティブです。<meta>タグに、width={value},height={value}の形式でcontent属性が含まれていることを確認してください。例：<meta content='width=300,height=250'>。",
          displayCampaignErr:
            "このマーケットプレイスではスポンサー付きディスプレイキャンペーンは利用できません。",
          bidErr: "入札金額が低すぎます。0.1以上の値を入力してください。",
        },
      },
      secondStep: {
        wordTargeting: "キーワードターゲティング",
        wordTargetingText: "広告を表示するキーワードを指定します。",
        categorySub: "広告が表示されるカテゴリーを指定します。",
        autoTargeting: "自動ターゲティング",
        autoTargetingText:
          "広告は最も関連性の高いキーワードとカテゴリーに表示されます。キーワードの停止は、キャンペーン詳細ページから行えます。",
        manualTargeting: "手動ターゲティング",
        manualTargetingText: "広告のキーワードを設定できます。",
        defaultBid: "デフォルトの入札",
        keywordTitle: "ターゲットキーワード",
        keywordText: "広告を表示するキーワードを追加します。",
        negativeTitle: "ネガティブキーワード",
        negativeText: "広告を表示したくないキーワードを追加します。",
        placementTitle: "ターゲティングタイプ",
        placementText:
          "キャンペーンが表示される特定のキーワードやカテゴリーをターゲットにできます。",
        search: "キーワードターゲティング",
        searchText: "キャンペーンが表示されるキーワードをターゲットにします。",
        categories: "カテゴリーターゲティング",
        categoriesText:
          "キャンペーンが表示されるカテゴリーをターゲットにします。",
        categoryTargeting: "ターゲティング",
        categoryTargetingTitle: "広告を表示するカテゴリーを指定します。",
        categoryTargetingText: "広告を表示するカテゴリーを追加します。",
        category: "ターゲットカテゴリー",
        negativeCategoryTitle: "ネガティブカテゴリー",
        negativeCategoryText: "広告を表示したくないカテゴリーを追加します。",
        autoCategoryText: "広告は最も適切なカテゴリーに表示されます。",
        manualCategoryText: "広告のターゲットカテゴリーを設定できます。",
        placement: "ターゲティング",
        targetingText: "キャンペーンのターゲティング戦略を設定できます。",
        bulkUploadCardTitle: "キーワードの一括追加",
        bulkUploadCardSubtitle:
          "ファイルを選択して、ワンクリックで全てのキーワードを追加します。",
        bulkUploadTabText: "一括アップロード",
        addManualTabText: "手動追加",
        bulkUpload: "キーワードの一括アップロード",
        reUpload: "再アップロード",
        uploadInfoText:
          "合計で<strong>{{count}}個のキーワード</strong>があります。",
        generalInformations: "一般情報",
        csvTemplateInstruction:
          "情報を正確にアップロードするために、<strong>CSVテンプレート</strong>を使用してください。",
        downloadCsvButton: "CSVテンプレートをダウンロード",
        formattingRules: "フォーマットのルール：",
        ruleAlphanumeric:
          "<strong>英数字</strong>のみを使用してください（特殊文字は使用しないでください）。",
        ruleMatchType:
          "マッチタイプは<strong>EXACT</strong>、<strong>PHRASE</strong>、または<strong>BROAD</strong>でなければなりません。",
        ruleBidValue:
          "入札額は最低入札額より<strong>高く</strong>なければなりません。",
        ruleExportCsv:
          "CSV を UTF-8 エンコーディングでエクスポートしてください。",
        minimumBidValue: "最低入札額:",
        uploadFileTitle: "ファイルをアップロード",
        uploadFileSubtitle:
          "ファイルをアップロードしてキーワードを追加します。",
        uploadDraggerText:
          "ファイルをドラッグ＆ドロップするか、<strong>参照</strong>",
        uploadDraggerFileType: "許可されているファイル形式: CSV",
        switchTabModal: {
          title: {
            manual: "手動入力に切り替えますか？",
            bulk: "一括アップロードに切り替えますか？",
          },
          warning: {
            manual:
              "一括アップロードから手動キーワード入力に切り替えようとしています。続行すると、全ての一括アップロードされたキーワードが削除され、復元できません。",
            bulk: "手動キーワード入力から一括アップロードに切り替えようとしています。続行すると、全ての手動で追加されたキーワードが削除され、復元できません。",
          },
          proceedQuestion: "本当に続行しますか？",
        },
        switchTabConfirmation: {
          deletion: {
            manual:
              "全ての一括アップロードされたキーワードが削除されることを理解しています。",
            bulk: "全ての手動で追加されたキーワードが削除されることを理解しています。",
          },
        },
        errorStates: {
          csvFileNotRead: "CSVファイルの読み取りエラー。",
          invalidCSVHeader: "無効なCSVヘッダー。",
          invalidCSVFile: "無効なCSVファイル。",
          invalidCSVBidValue: "無効なCSV入札額。",
          bidNotGreaterThanMin:
            "入札額は最低入札額より高くなければなりません。",
          invalidBidType: "無効な入札タイプ。",
          invalidEncoding:
            "CSV は UTF-8 でエンコードされている必要があります。",
          generalErr: "エラーが発生しました。",
        },
      },
      thirdStep: {
        targeting: "オーディエンス選択",
        targetingText: "広告を表示するオーディエンスを指定します。",
        autoTargeting: "自動ターゲティング",
        autoTargetingText:
          "広告は最も関連性の高いキーワードとカテゴリーに表示されます。",
        manualTargeting: "手動ターゲティング",
        manualTargetingText: "製品を表示させたいオーディエンスを決定できます。",
        platform: "プラットフォームターゲティング",
        platformText: "広告を表示するプラットフォームユーザーを指定します。",
        tablet: "タブレット",
        mobile: "モバイル",
        app: "モバイルアプリケーション",
        desktop: "デスクトップ",
        age: "年齢層ターゲティング",
        ageText: "広告を表示する年齢層を指定します。",
        city: "都市ターゲティング",
        cityText: "広告を表示する都市を指定します。",
        allCities: "すべての都市",
        selectedCities: "選択された都市",
        cityPlaceholder: "都市を選択",
        customer: "顧客ターゲティング",
        customerText: "購買履歴に基づいて広告を表示する顧客を指定します。",
        presentCustomers: "既存の顧客",
        presentCustomersText:
          "広告に出ている製品を注文したことのある顧客をターゲットにします。",
        newCustomers: "新規顧客",
        newCustomersText:
          "広告に出ている製品を一度も注文したことのない顧客をターゲットにします。",
        gender: "性別ターゲティング",
        genderText: "広告を表示する性別を指定します。",
        female: "女性",
        male: "男性",
        audience: "オーディエンス選択",
        audienceText: "広告を表示したいオーディエンスを選択します。",
        segment: "セグメントターゲティング",
        segmentText: "広告を表示したいセグメントを選択します。",
        allSegments: "すべてのセグメント",
        selectedSegments: "選択されたセグメント",
        segmentPlaceholder: "セグメントを選択",
      },
    },
    columnPopover: {
      title: "列を編集",
    },
    empty: {
      product_title: "製品を選択してください。",
      store_title: "店舗を選択してください。",
      dimensions_title: "次元が追加されていません。",
      product_text:
        "左側の製品リストの［追加］ボタンをクリックして、広告を表示させたい製品を追加できます。",
      store_text: "広告を表示させたい店舗を追加できます。",
      dimensions_text:
        "次元を追加して、キャンペーン結果の詳細レベルをカスタマイズできます。",
      null_title: "データなし",
      null_text: "テーブルにデータがありません。",
      categories_title: "対象にするカテゴリーを追加してください。",
      categories_text:
        "広告を表示したいカテゴリーを指定するには、カテゴリーを入力するか、推奨されるカテゴリー表の［追加］ボタンをクリックします。",
      keywords_title: "対象にするキーワードを追加してください。",
      keywords_text:
        "広告を表示したいキーワードを指定するには、キーワードを入力するか、推奨されるキーワード表の［追加］ボタンをクリックします。",
      negative_keywords_title: "ネガティブキーワードが追加されていません。",
      negative_keywords_text:
        "広告を表示させたくないネガティブキーワードを入力して指定できます。",
      negative_categories_title: "ネガティブカテゴリーが追加されていません。",
      negative_categories_text:
        "広告を表示させたくないネガティブカテゴリーを入力して指定できます。",
      campaigns_table_title: "キャンペーンが作成されていません",
      campaigns_table_text:
        "［新しいキャンペーンを追加］ボタンをクリックして、最初のキャンペーンを作成できます。",
      reports_table_title: "レポートが作成されていません",
      reports_table_text:
        "［新しいレポートを追加］ボタンをクリックして、最初のレポートを作成できます。",
      invoices_table_title: "残高が追加されていません",
      invoices_table_text:
        "広告費用（残高）を追加するには、アカウントマネージャーにお問合せください。",
      advertisers_table_title: "アカウントにリンクされた広告主がいません",
      advertisers_table_text: "アカウントマネージャーにお問合せください。",
      agencies_table_title: "代理店が作成されていません",
      agencies_table_text:
        "［新しい代理店を追加］ボタンをクリックして代理店を作成できます。",
      transactions_table_title: "残高が追加されていません",
      transactions_table_text:
        "［残高を追加］ボタンをクリックして、広告主のリストに広告費用（残高）を追加できます。",
      coupons_table_title: "クーポンが作成されていません",
      coupons_table_text:
        "［クーポンを設定］ボタンをクリックすると、広告主向けのクーポンを設定できます。",
      account_users_table_title: "ユーザーが作成されていません",
      account_users_table_text:
        "［新しいユーザーを追加］ボタンをクリックして、ユーザーを作成できます。",
      archived_table_reports_title: "アーカイブされたレポートはありません",
      archived_table_campaigns_title:
        "アーカイブされたキャンペーンはありません",
      archived_table_agencies_title: "アーカイブされた代理店はありません",
      archived_table_account_users_title: "アーカイブされたユーザーはいません",
      archived_table_advertisers_title: "アーカイブされた広告主はいません",
      archived_table_ad_placements_title:
        "アーカイブされた広告配置はありません",
      invited_table_users_title: "招待されたユーザーはありません",
      searched_table_title: "検索条件に一致する記録は見つかりませんでした。",
      searched_table_text: "nan",
      searched_title: "検索条件に一致する記録は見つかりませんでした。",
      searched_text: "nan",
      products_table_title: "製品が追加されていません。",
      products_table_text:
        "［製品を追加］ボタンをクリックして、広告を出したい製品を追加できます。",
      keywords_table_title: "キーワードが追加されていません。",
      keywords_table_text:
        "広告を表示したいキーワードを、単語を入力して指定できます。",
      categories_table_title: "カテゴリーが追加されていません。",
      categories_table_text:
        "広告を表示させたいカテゴリーを入力して指定できます。",
      negative_keywords_table_title:
        "ネガティブキーワードが追加されていません。",
      negative_keywords_table_text:
        "広告を表示させたくないネガティブキーワードを入力して指定できます。",
      negative_categories_table_title:
        "ネガティブカテゴリーが追加されていません。",
      negative_categories_table_text:
        "広告を表示させたくないネガティブカテゴリーを入力して指定できます。",
      sync_logs_table_title: "同期履歴データがありません",
      sync_logs_table_text: "同期履歴データが見つかりませんでした。",
      ad_placements_table_title: "広告配信面が追加されていません。",
      ad_placements_table_text:
        "［広告配信面を追加］ボタンをクリックして、広告配信面を追加できます。",
      creatives_table_title: "クリエイティブが追加されていません。",
      creatives_table_text:
        "追加されたクリエイティブは、後でここで確認できます。",
      creatives_relations_table_title: "クリエイティブが作成されていません。",
      creatives_relations_table_text:
        "キャンペーンフォームから新しいクリエイティブを作成できます。",
      creativeForm_title: "クリエイティブが追加されていません。",
      creativeForm_text: "推奨クリエイティブ「サイズ」：",
      invites_table_title: "ユーザーが招待されていません。",
      invites_table_text:
        "［新しいユーザーを追加］ボタンをクリックして、ユーザーを招待できます。",
      review_title: "レビューするクリエイティブはありません。",
      review_text:
        "すべてのクリエイティブが承認されたか、新しいクリエイティブがありません。承認待ちのクリエイティブは、この画面に表示されます。",
      accepted_table_creatives_title: "承認されたクリエイティブはありません。",
      accepted_table_creatives_text:
        "すべてのクリエイティブが拒否されたか、新しいクリエイティブがありません。",
      rejected_table_creatives_title: "拒否されたクリエイティブはありません。",
      rejected_table_creatives_text:
        "すべてのクリエイティブが承認されたか、新しいクリエイティブがありません。",
      pending_table_creatives_title: "追加されたクリエイティブはありません。",
      pending_table_creatives_text:
        "すべてのクリエイティブがレビューされたか、新しいクリエイティブがありません。",
      blacklist_table_title: "キーワード制限が見つかりませんでした。",
      blacklist_table_text:
        "［新しいキーワードを追加］ボタンをクリックして、制限を追加できます。",
      cities_table_title: "都市が追加されていません。",
      cities_table_text: "nan",
      age_ranges_table_title: "年齢範囲が追加されていません。",
      age_ranges_table_text: "nan",
      genders_table_title: "性別が追加されていません。",
      genders_table_text: "nan",
      platforms_table_title: "プラットフォームが追加されていません。",
      platforms_table_text: "nan",
      customers_table_title: "顧客が追加されていません。",
      customers_table_text: "nan",
      report_loading_title: "レポートを生成しています",
      report_loading_text:
        "レポートを作成中です。複雑さやサイズによっては、完了までに時間がかかることがあります。",
      data_sources_table_title: "データソースが見つかりません",
      data_sources_table_text:
        "現在、データソースはありません。データソースを追加して、インポートの詳細と履歴を確認してください。",
      logs_title: "ログが見つかりません",
      logs_text:
        "現在、このカテゴリには記録されたログはありません。関連するイベントが発生すると、ここにログが表示されます。",
      segments_table_title: "まだセグメントが追加されていません。",
      segments_table_text: "",
      meta_campaigns_table_title: "まだキャンペーンを作成していません。",
      meta_campaigns_table_text:
        "「新しいキャンペーンを追加」ボタンをクリックして、最初のキャンペーンを作成できます。",
      placements_table_title: "まだプレースメントが追加されていません。",
      placements_table_text: "",
    },
    endDatePicker: {
      label: "終了日",
      campaigns: "キャンペーンの終了日を選択します。",
      reports: "レポートの終了日を選択します。",
      button: "終了日なし",
    },
    reportForm: {
      title: "レポート情報",
      nameTitle: "レポート名",
      nameText: "レポートテーブルに表示される名前を入力します。",
      nameSub: "レポート名を入力します。",
      reportTypeTitle: "配信",
      reportTypeText:
        "レポートの配信方法を選択します。生成されたレポートは、指定した方法で配信されます。",
      static: "固定",
      staticText: "レポートは1回実行され、レポートに表示されます。",
      scheduled: "スケジュール設定",
      scheduledText: "レポートの頻度と受信者を選択します。",
      frequency: "レポートの頻度を選択します。",
      daily: "毎日",
      weekly: "毎週",
      monthly: "毎月",
      sendDate: "最初のレポートを受け取る日付を選択します。",
      firstDay: "月の初日",
      lastDay: "月の最終日",
      exportType: "レポートを受け取る形式を選択します。",
      mail: "レポートが送信されるメールアドレスを入力します。",
      dateTitle: "レポート日付",
      dateText: "レポートの開始日と終了日を選択します。",
      startDateSub: "レポートの開始日を選択します。",
      reportKindTitle: "レポートタイプ",
      reportKindText:
        "定義済みのレポートを使うと、簡単にパフォーマンスを測定できます。カスタムレポートを使うと、次元や指標、フィルターを追加して、自分に合わせたレポートを作成できます。",
      predefined: "定義済みのレポート",
      predefinedPlaceholder: "定義済みのレポートタイプを選択",
      special: "カスタムレポート",
      breaks: "次元",
      breaksText: "レポートに含める次元を選択します。",
      breaksPlaceholder: "次元を検索",
      maxWarning: "*レポートに最大4つの次元を追加できます。",
      clear: "クリア",
      metrics: "指標",
      metricsText: "レポートに含める指標を選択します。",
      filters: "フィルター：",
      filtersText: "次元と指標に適用するフィルターを選択します。",
      product: "製品のパフォーマンス",
      product_category: "カテゴリーのパフォーマンス",
      product_brand: "ブランドのパフォーマンス",
      keyword: "キーワードのパフォーマンス",
      campaign: "キャンペーンのパフォーマンス",
      advertiser: "広告主のパフォーマンス",
      agency: "代理店のパフォーマンス",
      errorStates: {
        date: "日付を選択してください。",
        mail: "メールアドレスを入力してください。",
        type: "レポートタイプを選択してください。",
        metric: "少なくとも1つの指標を選択してください。",
      },
      dimensions: {
        campaignId: "キャンペーン ID",
        campaignName: "キャンペーン名",
        campaignBidType: "入札タイプ",
        campaignBudgetType: "予算タイプ",
        product: "製品",
        categoryName: "カテゴリーのページ",
        keywordText: "キーワード",
        productBrand: "製品ブランド",
        productName: "製品",
        day: "日",
        week: "週",
        month: "月",
        year: "年",
        hour: "時間",
        advertiser: "広告主ID",
        advertiserName: "広告主",
        agency: "代理店ID",
        agencyName: "代理店",
        customerDeviceType: "顧客デバイスタイプ",
        saleProductName: "間接販売製品",
        placementId: "プレースメントID",
        customerType: "顧客タイプ",
        productRetailerTaxonomy: "製品カテゴリー",
        adPlacementCustomKey: "広告配信面ID",
        adPlacementName: "広告配信面名",
        placementText: "プレースメントテキスト",
        in_search: "検索結果",
        in_category: "カテゴリーのページ",
        in_product_detail_page: "製品詳細ページ",
        in_home_page: "ホームページ",
        campaignAdType: "キャンペーンタイプ",
        campaignBudget: "予算",
        campaignFixedBid: "キャンペーン固定入札",
        keywordBid: "キーワード入札",
        categoryBid: "カテゴリー入札",
        advertiserResourceID: "販売者ID",
        productSKU: "製品ID",
        customerDeviceEnvironmentType: "顧客デバイス環境タイプ",
        campaignDailyBudget: "1日の予算",
        campaignTotalBudget: "総予算",
        productMainCategory: "製品主要カテゴリー",
      },
      metric: {
        sumImpression: "インプレッション数",
        sumViewableImpression: "表示可能なインプレッション",
        sumClick: "クリック数",
        CTR: "CTR",
        CVR: "CVR",
        sumSale: "販売",
        ACoS: "ACoS",
        sumDirectSale: "直接販売",
        sumIndirectSale: "間接販売",
        sumDirectSaleAmount: "直接販売額",
        sumIndirectSaleAmount: "間接販売額",
        sumSaleAmount: "販売額",
        sumSpend: "支出",
        sale: "販売",
        sumVideoStart: "動画開始数",
        sumVideoComplete: "動画完了数",
        VCR: "動画完了率",
        viewabilityRate: "視認率",
        deliveryRate: "配信率",
        adResponseYieldRate: "広告応答収益率",
        fillRate: "充填率",
        sumPostClickSale: "ポストクリック販売",
        sumPostViewSale: "ポストビュー販売",
        sumPostClickSaleAmount: "ポストクリック販売額",
        sumPostViewSaleAmount: "ポストビュー販売額",
        sumPostClickDirectSale: "ポストクリック直接販売",
        sumPostClickIndirectSale: "ポストクリック間接販売",
        sumPostViewDirectSale: "ポストビュー直接販売",
        sumPostViewIndirectSale: "ポストビュー間接販売",
        sumPostClickDirectSaleAmount: "ポストクリック直接販売額",
        sumPostClickIndirectSaleAmount: "ポストクリック間接販売額",
        sumPostViewDirectSaleAmount: "ポストビュー直接販売額",
        sumPostViewIndirectSaleAmount: "ポストビュー間接販売額",
        ACoSByClick: "ポストクリックACoS",
        ACoSByView: "ポストビューACoS",
        RoASByClick: "ポストクリックRoAS",
        RoASByView: "ポストビューRoAS",
        CVRByClick: "ポストクリックCVR",
        CVRByView: "ポストビューCVR",
      },
    },
    selectFilter: {
      title: "フィルターオプション",
      placeholder: "フィルターを選択",
      budgetOpt: "残りの予算",
      budgetAdvertiser: "広告主名",
      placeholderCondition: "条件を選択",
      bigger: "より大きい",
      smaller: "より小さい",
      equal: "等しい",
      notEqual: "等しくない",
      any: "含む",
      add: "フィルターを追加",
      placeholderValue: "値を選択",
      enter: "値を入力",
      date: "日付を選択",
    },
    searchBar: {
      keywords: "キーワードを追加...",
      negative_keywords: "キーワードを追加...",
      categories: "カテゴリーを追加...",
      negative_categories: "カテゴリーを追加...",
    },
    settingsHeader: {
      general: "一般情報",
      generalText: "マーケットプレイスに関する一般情報",
      integration: "統合情報",
      integrationText: "データ転送を実行するために必要な統合情報",
      advertiser: "広告主設定",
      advertiserText: "広告主に関連する設定",
      auction: "オークション設定",
      auctionText: "オークションに関連する設定",
      campaign: "キャンペーン設定",
      campaignText: "キャンペーン設定に関連する設定",
      bid: "入札制限",
      bidText: "プラットフォーム全体の入札ルールの設定",
      conversion: "コンバージョン",
      conversionText: "プラットフォームのコンバージョン目標に関する設定",
      category: "カテゴリー制限",
      categoryText: "プラットフォーム上のカテゴリーごとの制限設定",
      keyword: "キーワード制限",
      keywordText: "プラットフォーム上で検索されるキーワードの制限",
      offsite: "オフサイト設定",
      offsiteText: "",
    },
    stepsNavbar: {
      report_create: "レポートを作成",
      campaign_create: "キャンペーンを作成",
      report_edit: "レポートを更新",
      step: "次のステップは {{value}}",
      advertiser: "広告主：",
    },
    suggestionCard: {
      addAll: "すべて追加",
    },
    table: {
      keywords: {
        keyword: "キーワード",
        matchType: "一致タイプ",
        suggested: "推奨入札額",
        dynamic: "自動",
        volume: "検索ボリューム",
        competition: "競争",
        search: "キーワードを追加...",
        suggestTitle: "推奨キーワード",
        suggestText: "製品の推奨キーワード。",
        negativePlaceholder: "ネガティブキーワードを追加...",
        exact: "キーワードに正確に一致する検索語句。",
        phrase: "キーワードのコンポーネントを同じ順序で含む検索語句。",
        broad: "キーワードのコンポーネントを任意の順序で含む検索語句。",
        warning: "最小値は、{{value}}である必要があります。",
      },
      products: {
        productSearch: "製品、SKU、バーコードを検索します。",
        storeSearch: "店舗を検索",
        loading: "読み込み中",
        title: "製品を選択してください。",
        text: "左側の製品リストの［追加］ボタンをクリックして、広告を表示させたい製品を追加できます。",
        productSelected: "選択された製品",
        storeSelected: "選択された店舗",
        remove: "すべて削除",
        price: "価格",
        stock: "在庫",
        rating: "評価",
        drawerTitle: "一括製品選択",
        sku: "SKUまたはバーコードリスト",
        skuText:
          "追加したい製品のSKUまたはバーコードを、以下のフィールドに1行ずつ入力します。",
        categories: "すべてのカテゴリー",
        bulk: "一括選択",
        all: "すべて表示",
        selected: "選択された製品を表示",
        total: "合計<strong>{{value}} 製品</strong>があります。",
        variable: "変数",
        video_with_productSearch: "製品、SKU またはバーコードを検索する。",
        display_with_productSearch: "製品、SKU またはバーコードを検索する。",
      },
      categories: {
        suggestTitle: "推奨カテゴリー",
        suggestText: "製品の推奨カテゴリー",
      },
      result: {
        campaignId: "キャンペーン ID",
        campaignName: "キャンペーン名",
        campaign: "キャンペーンID",
        campaignBidType: "入札タイプ",
        campaignBudgetType: "予算タイプ",
        advertiserName: "広告主名",
        agencyName: "代理店名",
        product: "製品",
        productName: "製品",
        categoryText: "カテゴリー",
        keyword: "キーワードID",
        keywordText: "キーワードテキスト",
        keywordMatchType: "一致タイプ",
        productBrand: "製品ブランド",
        day: "日",
        week: "週",
        month: "月",
        year: "年",
        hour: "時間",
        sumImpression: "インプレッション数",
        sumViewableImpression: "表示可能なインプレッション",
        sumClick: "クリック数",
        CTR: "CTR",
        CVR: "CVR",
        sumSale: "販売",
        ACoS: "ACoS",
        sumDirectSale: "直接販売",
        sumIndirectSale: "間接販売",
        sumDirectSaleAmount: "直接販売額",
        sumIndirectSaleAmount: "間接販売額",
        sumSaleAmount: "販売額",
        sumSpend: "支出",
        campaignStartDate: "開始日",
        campaignEndDate: "終了日",
        campaignStatus: "ステータス",
        campaignBudget: "予算",
        advertiser: "広告主",
        agency: "代理店",
        weekOf: "{{value}}の週",
        customerDeviceType: "顧客デバイスタイプ",
        saleProductName: "間接販売製品",
        placementId: "プレースメントID",
        customerType: "顧客タイプ",
        categoryName: "カテゴリーのページ",
        productRetailerTaxonomy: "製品カテゴリー",
        adPlacementCustomKey: "広告配信面ID",
        adPlacementName: "広告配信面名",
        placementText: "プレースメントテキスト",
        in_search: "検索結果",
        in_category: "カテゴリーのページ",
        in_product_detail_page: "製品詳細ページ",
        in_home_page: "ホームページ",
        in_collection: "コレクション",
        campaignAdType: "キャンペーンタイプ",
        campaignFixedBid: "キャンペーン固定入札",
        keywordBid: "キーワード入札",
        categoryBid: "カテゴリー入札",
        advertiserResourceID: "販売者ID",
        productSKU: "製品ID",
        customerDeviceEnvironmentType: "顧客デバイス環境タイプ",
        campaignDailyBudget: "1日の予算",
        campaignTotalBudget: "総予算",
        sumVideoStart: "動画開始数",
        sumVideoComplete: "動画完了数",
        VCR: "動画完了率",
        viewabilityRate: "視認率",
        deliveryRate: "配信率",
        adResponseYieldRate: "広告応答収益率",
        fillRate: "充填率",
        sumPostClickSale: "ポストクリック販売",
        sumPostViewSale: "ポストビュー販売",
        sumPostClickSaleAmount: "ポストクリック販売額",
        sumPostViewSaleAmount: "ポストビュー販売額",
        sumPostClickDirectSale: "ポストクリック直接販売",
        sumPostClickIndirectSale: "ポストクリック間接販売",
        sumPostViewDirectSale: "ポストビュー直接販売",
        sumPostViewIndirectSale: "ポストビュー間接販売",
        sumPostClickDirectSaleAmount: "ポストクリック直接販売額",
        sumPostClickIndirectSaleAmount: "ポストクリック間接販売額",
        sumPostViewDirectSaleAmount: "ポストビュー直接販売額",
        sumPostViewIndirectSaleAmount: "ポストビュー間接販売額",
        ACoSByClick: "ポストクリックACoS",
        ACoSByView: "ポストビューACoS",
        RoASByClick: "ポストクリックRoAS",
        RoASByView: "ポストビューRoAS",
        CVRByClick: "ポストクリックCVR",
        CVRByView: "ポストビューCVR",
        productMainCategory: "製品主要カテゴリー",
      },
    },
    states: {
      campaigns_not_started: "キャンペーンはまだ開始されていません。",
      campaigns_date_passed: "キャンペーンが、スケジュール終了日を過ぎました。",
      campaigns_status_paused: "キャンペーンを一時停止しました。",
      campaigns_out_of_daily_budget:
        "キャンペーンの1日の予算がすべて使われました。",
      campaigns_out_of_total_budget: "キャンペーンの総予算上限に達しました。",
      campaigns_products_stopped: "製品がアクティブではありません。",
      campaigns_keywords_stopped: "キーワードがアクティブではありません。",
      campaigns_categories_stopped: "カテゴリーがアクティブではありません。",
      campaigns_status_archived: "キャンペーンをアーカイブしました。",
      campaigns_creatives_stopped: "アクティブなクリエイティブがありません。",
      campaigns_insufficient_balance: "残高が不足しています。",
      campaigns_low_bid: "入札額が最低入札額を下回っています。",
      campaigns_regions_stopped: "地域がアクティブではありません。",
      products_status_paused: "製品を一時停止しました。",
      products_low_stock: "在庫の制約により、ステータスが停止されました。",
      products_low_rating: "評価の制約により、ステータスが停止されました。",
      products_buybox_loser:
        "Buy Boxの制約により、ステータスが停止されました。",
      products_product_paused: "製品がアクティブではありません。",
      products_product_deleted: "製品がアクティブではありません。",
      keywords_status_paused: "キーワードのステータスを一時停止しました。",
      keywords_low_bid: "入札額が最低入札額を下回っています。",
      categories_status_paused: "カテゴリーターゲティングが停止されました。",
      categories_low_bid: "入札額が最低入札額を下回っています。",
      creatives_paused: "クリエイティブのステータスを一時停止しました。",
      creatives_pending: "クリエイティブがレビュー待ちです。",
      creatives_rejected: "クリエイティブが拒否されました。",
      creatives_note: "拒否の理由:",
    },
    payment: {
      amount: "「チャージ」金額：",
      title: "支払い方法",
      subtitle: "広告残高はVATを含む価格で請求されます。",
      wire_transfer: "銀行振込 / EFT",
      beymen_milestone_payment: "マイルストーン支払い",
      koctas_milestone_payment: "マイルストーン支払い",
      bank: "銀行情報",
      helpUpper:
        "送金またはEFTでの支払いが承認された後、転送されます。承認プロセスは、",
      helpSecondary: "2〜3営業日かかります。",
      ref: "参照「番号」：",
      info: "取引の追跡のためには、取引の説明に参照番号を正しく入力することが非常に重要です。",
      tax: "VAT：",
      verifyAmount: "「口座」から引き出される額：",
      toters_milestone_payment: "ウォレットから転送",
      product_placeholder: "店舗を検索",
      craftgate: "クレジットカード",
    },
    tour: {
      prev: "戻る",
      next: "次へ",
      done: "ツアーを終了する",
      title: "広告プラットフォームへようこそ。",
      intro:
        "製品ツアーを表示するには、［開始］をクリックします。ツアーをスキップするには、［終了］ボタンをクリックします。",
      menu: "メニューバー",
      menuText: "左側のメニューバーを使用して、ページ間を移動できます。",
      campaigns: "キャンペーン",
      campaignsText:
        "［キャンペーン］ページから広告キャンペーンを管理できます。ここで、広告から得られるクリック数や販売数を確認できます。",
      reports: "レポート",
      reportsText:
        "広告のパフォーマンスに関するレポートを、さまざまな次元で作成できます。これらのレポートを使用すると、広告の表示回数、どの検索結果やカテゴリーで表示されたか、販売数などを確認できます。",
      reportsTextSub:
        "レポートを作成する際には、定義済みのレポートを選ぶか、自分で作成するカスタムレポートを選択できます。",
      invoices: "請求書",
      invoicesText:
        "このセクションでは、キャンペーンに使用するためにアップロードした残高、獲得したギフトクーポン、すべての広告費用を確認できます。",
      academy: "アカデミー",
      academyText:
        "ここでは、プラットフォームの使用に関する必要な情報を見つけることができます。",
      widgets: "統計",
      widgetsText:
        "作成したキャンペーンのパフォーマンスを段階的に確認できます。また、［グラフに表示］ボタンをクリックして日次ベースで広告パフォーマンスを詳細に確認することもできます。",
      table: "キャンペーンテーブル",
      tableText:
        "このセクションでは、作成したキャンペーンとそのパフォーマンスを確認できます。キャンペーンを一時停止することも可能です。キャンペーンの詳細を表示するには、キャンペーン名をクリックします。",
      button: "新しいキャンペーンを追加",
      buttonText:
        "［新しいキャンペーンを追加］ボタンをクリックして、最初の広告キャンペーンを作成します。",
      modal: "キャンペーンタイプ",
      modalText: "ここでは、選択可能な広告キャンペーンの種類を確認できます。",
      type: "スポンサー製品",
      typeText:
        "スポンサー製品のキャンペーンを作成すると、検索結果やカテゴリーページの上位に製品を表示させることができます。",
    },
    widget: {
      title: "メトリクスの日付範囲",
      description:
        "メトリクスを表示するために、開始日と終了日を選択してください。デフォルトは過去30日間で、未来の日付は選択できません。",
    },
    offsiteCampaignForm: {
      campaignInfoTitle: "広告情報",
      adSummary: "広告の選択内容を確認してください。",
      info: "一般情報",
      productName: "商品名とカバー:",
      adName: "広告名:",
      budget: "予算:",
      noAdAccountErr: "Meta広告アカウントが見つかりませんでした。",
      noFacebookPageErr: "Facebookページが設定されていません。",
      generalErr: "キャンペーンの作成中にエラーが発生しました。",
      firstStep: {
        budget: "予算",
        budgetText:
          "キャンペーンの予算タイプを選択し、予算を設定してください。支出が予算に達すると、キャンペーンは自動的に停止します。",
        budgetLabel: "日予算",
        budgetError: "有効な予算を入力してください。",
        urlTitle: "リダイレクト URL",
        urlText:
          "これは、広告をクリックしたユーザーが移動するページです。ユーザーをマーケットプレイス内のページにリダイレクトする必要があります。",
        urlLabel: "リダイレクト URL",
        urlError: "有効な URL を入力してください。",
        adPreview: "広告プレビュー",
        adPreviewText: "広告の詳細がここに表示されます。",
        pleaseSelectProduct:
          "広告をプレビューするには、商品を選択してください。",
        productName: "商品名とカバー",
        destination: "遷移先",
        displayLink: "表示リンク",
        primaryText: "主要テキスト",
        primaryTextText: "広告の主要テキストを入力してください。",
        headline: "見出し",
        headlineText: "広告の見出しを入力してください。",
        description: "説明",
        descriptionText: "広告の説明を入力してください。",
        cta: "CTA:",
        fixedCta: "今すぐ購入",
        editAd: "広告を編集",
        adName: "広告名",
        adNameText: "広告名を入力してください。",
        audience: "オーディエンス",
        audienceText:
          "オーディエンスを定義してターゲット設定し、適切な顧客にリーチしましょう。",
        setAudience: "オーディエンスを設定",
        defineAudience:
          "簡単にオーディエンスを定義してターゲット設定しましょう。",
        set: "設定",
        selectAudience: "オーディエンスを選択",
        audienceSelection: "オーディエンス選択",
        audienceSelectionText:
          "以下のオプションからターゲットオーディエンスを選択してください。",
        selectAudiencePlaceholder: "オーディエンスを選択",
        audienceNote:
          "キャンペーンには一種類のオーディエンスのみ選択可能です。",
        scheduleTitle: "スケジュール",
        scheduleText: "キャンペーンの開始日と終了日を選択してください。",
        durationTitle: "期間を選択：",
        oneWeek: "1週間",
        oneMonth: "1か月",
        threeMonths: "3か月",
        custom: "カスタム",
        durationError:
          "期間を選択するか、カスタムの日付範囲を入力してください。",
        orEnterDays: "または日数を入力",
        durationInput: "期間",
        endDateText: "終了日は次のとおりです：",
        durationDays: "日間",
        scheduleOR: "または",
      },
    },
  },
  pages: {
    acc: {
      campaigns: {
        button: "新しいキャンペーンを追加",
        placeholder: "キャンペーン内を検索",
        errorTitle: "広告主が選択されていません",
        errorText: "広告主を選択してください。",
        table: {
          standart: "自動",
          max_acos: "自動",
          fixed: "固定",
          daily: "毎日",
          flexible: "毎日",
          total: "合計",
          budgetLimit: "{{value}}に制限",
          stopped: "キャンペーンを停止しました。",
          product: "スポンサー製品",
          display: "スポンサーディスプレイ",
          store: "スポンサーストア",
          default: "デフォルトのビュー",
          checkUp: "チェックアップビュー",
          display_with_product: "スポンサーディスプレイ（製品付き）",
          video_with_product: "スポンサービデオ（製品付き）",
        },
      },
      campaignDetails: {
        subtext: "キャンペーン情報を編集できます。",
        products: "製品",
        on: "アクティブ",
        keywords: "キーワード",
        negativeKeywords: "ネガティブキーワード",
        targeting: "オーディエンス",
        city: "都市",
        age: "年齢",
        gender: "性別",
        platform: "プラットフォーム",
        customers: "顧客",
        placements: "広告配信面",
        in_search: "検索結果",
        in_category: "カテゴリー",
        placementPlaceholder: "広告配信面内を検索",
        date: "開始-終了「日」：",
        bid: "入札：",
        maxAcos: "% 最大ACoS",
        fixed: "固定",
        standart: "自動",
        daily: "毎日",
        total: "合計",
        flexible: "毎日",
        none: "なし",
        keywordsBtn: "キーワードを追加",
        keywordsPlaceholder: "キーワードを検索",
        keywordsSub: "広告を表示するキーワードを追加します。",
        negative_keywords_btn: "ネガティブキーワードを追加",
        negative_keywords_placeholder: "ネガティブキーワード内を検索",
        negative_keywords_modal_subtitle:
          "広告を表示したくないキーワードを追加します。",
        negative_categories_btn: "ネガティブカテゴリーを追加",
        negative_categories_placeholder: "ネガティブカテゴリー内を検索",
        negative_categories_modal_subtitle:
          "広告を表示したくないカテゴリーを追加します。",
        productsBtn: "製品を追加",
        productsPlaceholder: "製品を検索",
        productsSub: "広告を出したい製品を選択します。",
        cities_placeholder: "都市を検索",
        age_ranges_placeholder: "年齢範囲を検索",
        genders_placeholder: "性別を検索",
        platforms_placeholder: "プラットフォームを検索",
        customers_placeholder: "顧客タイプを検索",
        new: "新規顧客",
        present: "既存の顧客",
        keywordTitle: "キーワードターゲティング",
        keywordText:
          "キーワードは自動的に広告のターゲットに設定されます。ターゲットにしたくないキーワードは停止できます。",
        maxAcosLabel: "最大ACoS",
        fixedBidLabel: "固定入札",
        productsError: "少なくとも1つの製品がアクティブである必要があります。",
        keywordsError:
          "少なくとも1つのキーワードがアクティブである必要があります。",
        categoriesError:
          "少なくとも1つのカテゴリーがアクティブである必要があります。",
        categories: "カテゴリー",
        categoriesBtn: "カテゴリーを追加",
        categoriesPlaceholder: "カテゴリー内を検索",
        categoriesSub: "ターゲットにするカテゴリーを追加できます。",
        negativeCategories: "ネガティブカテゴリー",
        buyboxError: "製品はBuy Boxを獲得していません。",
        ratingError: "製品の評価が最低評価を下回っています。",
        stockError: "製品の在庫が最低在庫を下回っています。",
        notActiveError: "製品がアクティブではありません。",
        creatives: "クリエイティブ",
        creativesBtn: "クリエイティブを追加",
        creativesPlaceholder: "クリエイティブ内を検索",
        creativesSub: "広告に表示するクリエイティブを追加します。",
        creativesLinkTitle: "リダイレクトURL",
        creativesLinkText:
          "広告をクリックしたユーザーは、{{value}} にリダイレクトされます。",
        winner: "勝者",
        loser: "敗者",
        creativesError:
          "少なくとも1つのクリエイティブがアクティブである必要があります。",
        pendingError: "保留中のクリエイティブはアクティブにできません。",
        rejectedError: "拒否されたクリエイティブはアクティブにできません。",
        in_product_detail_page: "製品詳細ページ",
        in_home_page: "ホームページ",
        in_collection: "コレクション",
        scheduled: "スケジュール済み",
        dayParting: "キャンペーンがアクティブになる曜日と時間を選択できます。",
        region: "地域:",
        regionLength: "{{value}} 地域",
        regionsDrawerTitle: "地域を更新",
        languages: "{{value}} 言語",
        segments: "セグメント",
        segments_placeholder: "セグメントを検索",
        categoryLimitError:
          "最大制限に達しました。最大 100 個のカテゴリを追加できます。新しいカテゴリを追加するには、既存のものを一時停止してください。",
        keywordLimitError:
          "最大制限に達しました。最大 100 個のキーワードを追加できます。新しいキーワードを追加するには、既存のものを一時停止してください。",
        updateRedirectUrl:
          "ユーザーが広告をクリックしたときにリダイレクトされるURLを編集できます。「編集」ボタンをクリックしてリンクを更新してください。",
        redirectUrlWarning:
          "リダイレクトURLを更新すると、すべてのクリエイティブが再審査の対象となります。承認が完了するまで広告は表示されません。",
        in_store_entrance: "入口",
        in_store_register: "レジ",
        in_store_basket: "トイレ",
        in_store_shelf: "セルフレジ",
        in_store_garden: "ガーデン",
        in_store_paint: "ペイント",
        campaignUpdated: "キャンペーンが正常に更新されました。",
        keywordUpdated: "キーワードが正常に更新されました。",
        categoryUpdated: "カテゴリが正常に更新されました。",
        negativeKeywordUpdated: "除外キーワードが正常に更新されました。",
        negativeCategoryUpdated: "除外カテゴリが正常に更新されました。",
        regionsUpdated: "地域が正常に更新されました。",
        redirectUrlUpdated: "リダイレクトURLが正常に更新されました。",
        pausedUpdated: "キャンペーンが一時停止されました。",
        activeUpdated: "キャンペーンが有効化されました。",
        updateError: "キャンペーンの更新中にエラーが発生しました。",
        productUpdated: "製品が正常に更新されました。",
      },
      noMatch: {
        title: "ページが見つかりません。",
        btn: "ホームに戻る",
      },
      reports: {
        button: "新しいレポートを追加",
        placeholder: "レポート内を検索",
        name: "レポート名",
        table: {
          type: "レポートタイプ",
        },
        form: {
          title: "レポート1",
          goBack: "戻る",
          create: "レポートを作成",
        },
      },
      reportDetails: {
        result: "レポート結果",
        static: "固定",
        scheduled: "スケジュール設定",
        ready: "定義済みのレポート",
        startDate: "開始日",
        endDate: "終了日",
        frequency: "頻度",
        firstDate: "最初の投稿日",
        month: "月の初日",
        emails: "メール",
        export: "ファイルタイプ",
        predefined: "定義済みのレポートタイプ",
        total: "合計統計を取得",
      },
      invoice: {
        balance: "残高",
        coupon: "クーポン",
        lastPayment: "最後に追加された残高",
        searchPlaceholder: "請求書内を検索",
        duplicateCouponsError:
          "複数のクーポン定義が検出されました。しばらくお待ちください。",
        multipleTopUpsError:
          "複数の残高アップロードが検出されました。しばらくお待ちください。",
        limitError:
          "高額の残高を追加しようとしています。金額を確認してください。",
        minAmountError: "最低支払額は {{value}} である必要があります。",
        data: {
          typeBudget: "残高支払い",
          typeAd: "広告費用",
          typeBudgetExplanation: "広告残高を追加しました。",
          typeAdExplanation: "広告費用を使用しました。",
        },
        table: {
          type: "取引タイプ",
        },
        modal: {
          button: "残高を追加",
          title: "残高を追加",
          subtitle: "広告残高に転送したい金額を入力します。",
          loadingAmount: "金額",
          differentAmount: "金額を入力",
          label: "金額",
        },
      },
      academy: {
        more: "詳細を見る",
        copy: "リンクをコピー",
        helpTitle: "質問に対する回答が見つかりませんか？",
        helpText:
          "ご不明な点がございましたら、サポートチームまでメールでお問い合わせください。",
        contact: "お問い合わせ",
        highlights: "ハイライト",
        read: "記事の残りを読む",
        description:
          "{{value}}の広告ガイドの役立つ記事をご覧ください。プラットフォームに関する知識が身につき、簡単に広告を掲載できるようになります。",
      },
      offsiteCampaigns: {
        button: "新しいキャンペーンを追加",
        placeholder: "キャンペーン内を検索",
        errorTitle: "広告主が選択されていません",
        errorText: "広告主を選択してください。",
        OUTCOME_TRAFFIC: "トラフィック成果",
        OUTCOME_ENGAGEMENT: "エンゲージメント成果",
        OUTCOME_SALES: "売上成果",
        OUTCOME_LEADS: "リード成果",
        OUTCOME_AWARENESS: "認知成果",
        failedText:
          "キャンペーンが失敗しました。キャンペーンの詳細を確認し、新しいキャンペーンを作成してください。",
      },
      offsiteDetails: {
        updateError: "キャンペーンの更新中にエラーが発生しました。",
        updateSuccess: "キャンペーンが正常に更新されました。",
      },
    },
    admin: {
      advertisers: {
        updateSubtext: "広告主を代理店に割り当ててグループ化できます。",
        modalPlaceholder: "代理店を検索...",
        search: "広告主内を検索",
        select_advertiser_subtitle:
          "キャンペーンを作成する広告主を選択してください。",
        userSubtext: "広告主アカウントを使用するユーザーを招待できます。",
        help: "ユーザーのメールアドレスを追加",
        deleteSuccess: "代理店が削除されました。",
        create: "新しい広告主を追加",
        update: "広告主を更新",
        type: "広告主「タイプ」：",
        custom: "カスタム",
        customText:
          "プラットフォーム内で共有可能なベンダーの製品を使って作成された広告主のタイプです。",
        name: "広告主名",
        nameHelp: "表示される広告主の名前です。",
        agency: "代理店",
        agencyHelp: "広告主が所属する代理店です。",
        email: "メール",
        emailHelp:
          "招待状を送信するメールアドレスを入力します。販売者はプラットフォームにログインする際に、このメールアドレスを使用します。",
        product: "製品名",
        brand: "ブランド",
        retailer_taxonomy: "製品カテゴリー",
        advertiser_id: "広告主ID",
        filters: "フィルター：",
        filterWarning: "少なくとも1つのフィルターを追加してください。",
        typeTitle: "広告主のタイプ",
        typeSubtext:
          "以下のうち、上で選択した広告主のタイプをどれに変更しますか？",
        default: "デフォルト",
        defaultText:
          "プラットフォーム内で自分の名前で直接販売する販売者アカウントに使用されます。",
        shareable: "共有可能",
        shareableText:
          "プラットフォーム内で他者の代理として販売を行い、売上を主要な販売者に配分するための販売者アカウントに使用されます。",
        generalTitle: "一般情報",
        generalSubtext: "広告主に関する一般情報",
        successText:
          "選択した販売者のブランドに一致する、すべての製品が追加されました。",
        advertiser: "広告主：",
        drawerFilterWarning: "追加したフィルターは元に戻せません。",
        filterTitle: "フィルター",
        keyLabel: "フィルターを選択",
        opLabel: "条件を選択",
        valueLabel: "値を入力",
        categorySelectLabel: "カテゴリーを選択",
        filterKeyError: "フィルターを選択してください。",
        filterOpError: "条件を選択してください。",
        filterValueError: "値を入力してください。",
        filterCategoryError: "カテゴリーを選択してください。",
        invalidAdvertiserTypeChange: "広告主タイプの更新リクエストが無効です。",
      },
      advertiserSettings: {
        title: "広告主設定",
        subtext: "広告主に関連する設定",
        status: "デフォルトの広告主ステータス",
        statusText:
          "プラットフォームに追加された広告主のデフォルトステータスが無効になっている場合、広告主ページでステータスを有効にし、システムにログインできるようにする必要があります。",
        welcome: "ウェルカムクーポン",
        welcomeText:
          "広告主がプラットフォームに初めてアクセスした時に使用可能なウェルカムクーポンを設定できます。",
        warning:
          "「0」を入力すると、広告主にはウェルカムクーポンが定義されません。",
        label: "クーポン残高",
        language: "言語",
        languageText:
          "広告主のデフォルトのインターフェイス言語です。広告主は自身のインターフェイスを通じて言語選択を変更できます。",
        balance: "残高移行の承認",
        balanceText:
          "広告主がインターフェイスを通じて進捗支払いを広告残高に移行するための権限です。",
        open: "開く",
        closed: "閉じる",
        error_title: "値を入力する必要があります。",
        error_text:
          "クーポンを設定しない場合は、「0」を入力して［保存］ボタンをクリックできます。",
        error_text_input: "値を入力する必要があります。",
      },
      agencies: {
        label: "代理店名",
        subtext: "代理店名を入力",
        subtitle: "代理店を追加して、広告主をグループ化できます",
        search: "代理店内を検索",
        edit: "代理店名を更新",
      },
      auctionSettings: {
        title: "オークション設定",
        subtext: "オークションに関連する設定",
        type: "オークションタイプ",
        typeText:
          "広告主の入札額が評価されるオークションタイプを選択します。オークションタイプの詳細情報は、こちらをご覧ください。",
        warning:
          "この設定を変更すると、プラットフォーム上の広告費に影響を与えます。",
        firstOpt: "第一価格",
        firstOptText: "落札した広告主は提出した入札額を支払います。",
        secondOpt: "第二価格",
        secondOptText:
          "落札した広告主は2番目に高い入札額より1セント高い金額を支払います。",
        link: "オークションタイプ",
      },
      campaignSettings: {
        title: "キャンペーン設定",
        subtext: "キャンペーン設定に関連する設定",
        conversionRange: "コンバージョン期間",
        conversionRangeText:
          "ユーザーが広告をクリックしてから、そのクリックによる購入として計上されるまでの期間を設定できます。例えば、コンバージョン期間を7日に設定すると、ユーザーが広告をクリックしてから7日以内に製品を購入した場合、その購入がキャンペーン費用として計上されます。",
        product: "製品評価",
        productText:
          "広告主がキャンペーンに追加する製品の最低評価要件を設定でき、条件を満たしていない製品の扱いをカスタマイズできます。",
        minimum: "製品の最低評価",
        minimumText: "キャンペーンに追加する製品の最低評価を入力します。",
        behaviour: "動作設定",
        behaviourText: "キャンペーンに追加する製品の最低評価を入力します。",
        placeholder: "動作を選択",
        stock: "製品在庫",
        stockText:
          "広告主がキャンペーンに追加する製品の最低在庫要件を設定でき、条件を満たしていない製品の扱いをカスタマイズできます。",
        minimumStock: "最低在庫数",
        minimumStockText:
          "キャンペーンに追加する製品の最低在庫数を入力します。",
        stockBehaviourText:
          "指定した最低在庫を下回ったときの動作を指定します。",
        alert: "警告のみ",
        block: "警告と広告をブロック",
        targeting: "属性ターゲティング",
        targetingText:
          "キャンペーン設定時に、属性ターゲティングの設定を有効にするかどうかを選択します。有効にすると、キャンペーン設定に追加の手順が追加され、広告主がターゲティングの設定を行えるようになります。",
        all: "すべての広告主",
        none: "広告主なし",
        selected: "選択した広告主",
        format: "広告形式",
        sponsored: "スポンサー製品",
        brand: "スポンサーブランド",
        ad: "ビジュアル広告",
        rating_warn:
          "製品に対する評価が低すぎます。この製品をキャンペーンに追加すると、パフォーマンスが低下します。",
        rating_block:
          "製品に対する評価が低すぎます。この製品をキャンペーンに追加できません。",
        stock_warn:
          "在庫が少なすぎます。この製品をキャンペーンに追加すると、パフォーマンスが低下します。",
        stock_block:
          "在庫が少なすぎます。この製品をキャンペーンに追加できません。",
        buybox_warn:
          "この製品はBuy Boxを獲得していません。この製品をキャンペーンに追加すると、パフォーマンスが低下します。",
        buybox_block: "製品はBuy Boxを獲得していません。",
        buyBoxTitle: "Buy Boxの条件",
        buyBoxText:
          "広告主がキャンペーンに追加する製品に対して、Buy Boxの獲得条件を追加することができます。",
        buyBoxSubtext:
          "キャンペーンに追加する製品がBuy Boxの勝者でない場合の動作を指定します。",
        noWorning: "なし",
        warn: "この設定を変更すると、すべてのアクティブなキャンペーンに影響を与えます。",
        rangeError: "値を入力する必要があります。推奨値は7日間です。",
        rangeErrorInput: "1〜14日間の範囲でのみ設定できます。",
        chooseBehaviour: "動作を選択する必要があります。",
        stockError: "最低在庫を入力する必要があります。",
        allStockError: "最低在庫を入力し、動作を選択する必要があります。",
        ratingError: "最低評価を入力する必要があります。",
        allRatingError: "最低評価を入力し、動作を選択する必要があります。",
        serverBlock: "警告と広告表示をブロック",
        advertisers: "選択した広告主",
        advertisersText:
          "属性ターゲティングは、選択した広告主のみが利用可能になります。",
        advertisersBtn: "広告主を追加",
        advertisersSub: "属性ターゲティングを使用可能な広告主を選択します。",
        advertisersPlaceholder: "広告主を選択",
        advertisersLength: "{{value}} 件の広告主が選択されました。",
        advertisersTitle: "広告主",
        general: "一般",
        bid: "入札制限",
        conversion: "コンバージョン",
        conversionSubtext:
          "プラットフォームでのコンバージョン目標に関連する設定",
        biddingTypes: "スポンサー製品の入札タイプ",
        biddingTypesText:
          "キャンペーンの作成ステップで、広告主が使用できる入札タイプを指定できます。",
        biddingTypesWarning: "少なくとも1つのオプションを開く必要があります。",
        auto: "自動入札",
        autoText:
          "入札額が自動的に決定される入札タイプです。費用は販売された製品の価格と設定したターゲットACoSを使用して計算されます。",
        acos: "ターゲットACoS",
        acosText:
          "入札額は、広告主が入力したACoSの率と販売された製品の価格に基づいて、自動的に計算されます。",
        fixed: "固定入札",
        fixedText:
          "入札額は広告主によって決定されます。広告主はキーワードおよびカテゴリーごとにキャンペーン全体の入札額を設定できます。",
        bidWarning: "少なくとも1つの入札タイプが選択されている必要があります。",
        bidText: "プラットフォーム全体の入札ルール設定",
        bidLabelTitle: "全体最低CPC",
        bidLabelText:
          "すべてのカテゴリーおよびキーワードに対して適用される、1クリックあたりの最低入札額です。",
        bidLabel: "最低CPC",
        cpmTitle: "全体最低CPM",
        cpmText:
          "すべてのカテゴリーおよびキーワードに対して適用される、1,000インプレッションあたりの最低入札額です。",
        cpmLabel: "最低CPM",
        targetAcosTitle: "標準ターゲットACoS",
        targetAcosText:
          "オークションでデフォルトの広告費用対売上高 (ACoS) の最大パーセンテージを設定します。",
        targetAcosLabel: "最大ACoS",
        categoryRelevanceTitle: "標準カテゴリー関連性",
        categoryRelevanceText:
          "広告インプレッションにおいて、スポンサー製品と自然検索リストの製品との関連性レベルを設定します。",
        categoryRelevanceLabel: "カテゴリー関連性",
        bidTabWarning:
          "この設定を変更すると、プラットフォーム上の広告費やインプレッション数に影響を与えます。",
        inputErrorZero: "ゼロより大きい値を入力する必要があります。",
        inputErrorAcos: "0〜100の間の値を入力する必要があります。",
        inputErrorRelevance: "ゼロより大きい整数を入力する必要があります。",
        inputError: "値を入力する必要があります。",
        productLink: "製品レート制限",
        stockLink: "製品在庫制限",
        targetingLink: "属性ターゲティング機能",
        bidLink: "入札タイプ",
        minThreshold: "最低販売閾値",
        minThresholdText:
          "これは、製品をオークションに含めるための最低販売閾値です。",
        minThresholdLabel: "最低販売閾値",
        minThresholdError: "整数を入力してください。",
        formatTitle: "フォーマット別アトリビューション設定",
        formatText:
          "タッチポイントは、さまざまなキャンペーン形式での有効性を測定するために評価されます。形式に応じて、インプレッションを選択すると視認性が追跡され、クリックは直接のエンゲージメントを通じてコンバージョンの測定に焦点を当てます。",
        sponsoredProductTitle: "スポンサー製品",
        sponsoredProductText:
          "製品広告では、コンバージョンはユーザーの広告とのインタラクションに基づいて評価され、エンゲージメントまたは露出が目標達成にどれだけ効果的かに焦点が当てられます。",
        sponsoredDisplayTitle: "スポンサー表示",
        sponsoredDisplayText:
          "ディスプレイ広告では、単なる可視性がユーザーの行動に影響を与えるか、または成功に向けてより深いインタラクションが必要かを分析してコンバージョンを測定します。",
        sponsoredVideoTitle: "スポンサー動画",
        sponsoredVideoText:
          "動画広告では、コンバージョンの測定は、単にコンテンツを視聴することが目標達成にどれほど寄与するか、またはアクティブなエンゲージメントがどれだけ効果的かに焦点を当てます。",
        postView: "ポストビュー",
        postClick: "ポストクリック",
        reportTitle: "レポート別コンバージョン設定",
        reportText:
          "このオプションは、レポート目的でコンバージョンをどのように適用するかを定義し、選択されたアプローチに基づいてデータがどのように整理および表示されるかを形成します。",
        marketplaceReport: "マーケットプレイスレポートでの指標分割",
        marketplaceReportText:
          "このオプションを有効にすると、マーケットプレイスレポート内の指標がコンバージョンごとに分割され、各タッチポイントのパフォーマンスをより明確に把握できます。",
        advertiserReport: "広告主レポートでの指標分割",
        advertiserReportText:
          "このオプションをオンにすると、広告主レポート内の指標がコンバージョンごとに分割され、異なるキャンペーンの影響をより良く理解するのに役立ちます。",
        widgetTitle: "ウィジェット変換設定",
        widgetText:
          "ウィジェット変換は、コンバージョンジャーニー全体にわたるユーザーのインタラクションを評価します。インプレッションを追跡することを選択すると広告の可視性が捉えられ、クリックを追跡するとエンゲージメントがコンバージョン指標として測定されます。",
      },
      console: {
        add: "新しいデータソースを追加",
        advertiser: "広告主",
        product: "商品",
        google_feed_url_scheduler: "Google Feed URL",
        google_feed_file: "Google フィードファイルアップロード (XML)",
        google_feed_body: "Google フィード直接 XML",
        meta_feed_url_scheduler: "Meta フィード URL",
        minutes_15: "15分",
        minutes_30: "30分",
        hour_1: "1時間",
        hours_2: "2時間",
        hours_3: "3時間",
        hours_4: "4時間",
        hours_6: "6時間",
        hours_12: "12時間",
        hours_24: "24時間",
        history: "履歴を表示",
        logs: "ログを表示",
        drawer: "ログビュー",
        error: "エラー",
        warning: "警告",
        success: "成功",
        info: "情報",
        prev: "前の 50 ログ",
        next: "次の 50 ログ",
        api: "API",
        impression: "インプレッション",
        click: "クリック数",
        sale: "販売",
        test: "テスト",
        curlTest: "テストビュー",
        curlWarning: "重要: 本番環境でこのプロセスを実行しないでください！",
        request: "リクエスト",
        run: "実行",
        response: "レスポンス",
        hide: "生データを隠す",
        show: "生データを表示",
        auctionLogs: "オークションログ",
      },
      coupons: {
        add: "クーポンを設定",
        title: "広告主情報",
        subtext: "広告主がキャンペーンで利用するためのクーポンを設定できます。",
        label: "有効期限",
        warning:
          "広告主は入力された日付までにクーポンを利用する必要があります。有効期限を入力しない場合、クーポンは広告主の残高に追加され（期限なし）、広告主はいつでもクーポンを使用することができます。",
        gift_coupon: "ギフトクーポン",
        welcome_coupon: "ウェルカムクーポン",
        gift_coupon_desc: "ギフトクーポンを設定しました。",
        welcome_coupon_desc: "ウェルカムクーポンを設定しました。",
        approve: "クーポンの設定を続行しますか？",
        note: "クーポンの説明",
        noteHelp:
          "クーポンを設定する理由を入力してください。例：ブラックフライデーのクーポン",
      },
      createDatasource: {
        title: "データソースを追加",
        save: "保存して実行",
        existsErr:
          "このURLのデータソースはすでに存在します。別のURLを使用してください。",
        feedErr:
          "このタイプのインテグレーションでは、フィードURLを空にすることはできません。有効なURLを入力してください。",
        cycleErr:
          "このタイプのインテグレーションでは、サイクル間隔を空にすることはできません。有効な間隔を指定してください。",
        permissionErr:
          "指定されたURLにアクセスできません。URLまたは権限を確認してください。",
        generalErr: "エラーが発生しました。",
        validateSuccess: "検証成功",
        validateSuccessText:
          "すべての必須フィールドが正しくマッピングされました。続行の準備ができました。",
      },
      creatives: {
        all: "すべて",
        accepteds: "承認済み",
        rejecteds: "拒否済み",
        pendings: "保留中",
        pending: "保留中",
        accepted: "承認済み",
        rejected: "拒否済み",
        adModalTitle: "広告プレビュー",
        creativeModalTitle: "クリエイティブプレビュー",
        creative: "クリエイティブ",
        name: "クリエイティブ名",
        search: "クリエイティブ内を検索",
        rejectSubtitle:
          "クリエイティブを拒否する理由を入力するか、空白のまま続行できます。",
        note: "クリエイティブを拒否する理由を入力してください。",
      },
      datasourceDetails: {
        entity: "エンティティ:",
        import: "インポートタイプ:",
        cycle: "インターバルサイクル:",
        url: "Feed URL:",
        success: "成功",
        failure: "失敗",
        in_progress: "進行中",
        partial_success: "部分的な成功",
      },
      generalInfo: {
        title: "一般情報",
        subtext: "マーケットプレイスに関する一般情報",
        market: "マーケットプレイス名",
        marketText:
          "インターフェイスに表示されるストア名です。この情報を変更するには、アカウントマネージャーにお問合せください。",
        url: "URL",
        urlText:
          "インターフェイス上での表示やアクセス先の設定に使用されるストアのリンクです。この情報を変更するには、アカウントマネージャーにお問合せください。",
        country: "国",
        countryText:
          "都市ターゲティングに使用される国です。この情報を変更するには、アカウントマネージャーにお問合せください。",
        zone: "タイムゾーン",
        zoneText:
          "インターフェイスで使用されるデフォルトのタイムゾーンです。この情報を変更するには、アカウントマネージャーにお問合せください。",
        currency: "通貨",
        currencyText:
          "インターフェイスで使用される通貨です。この情報は変更できません。",
        zoneIstanbul: "ヨーロッパ/イスタンブール",
        email: "サポート用メールアドレス",
        emailText: "販売者が連絡を取るためのメールアドレスです。",
        emailLabel: "メール",
        emailError: "メールアドレスを入力する必要があります。",
        seller: "販売者パネル",
        sellerText:
          "インターフェイスを通じて販売者が直接パネルにアクセスできるアドレスです。",
        sellerLabel: "販売者パネル",
        marketError: "マーケットプレイスの名前を入力する必要があります。",
        urlError: "URLを入力する必要があります。",
      },
      inspect: {
        campaign: "キャンペーン：",
        advertiser: "広告主：",
        url: "URL：",
        size: "サイズ：",
        status: "ステータス：",
        keywords: "キーワード",
        categories: "カテゴリー",
        languages: "言語:",
        regions: "地域:",
      },
      integrationInfo: {
        title: "統合情報",
        subtext: "データ転送を行うために必要な統合情報",
        api: "APIセキュリティーコード",
        apiText:
          "プラットフォームにAPI経由でアクセスするために必要なセキュリティーコードです。",
        ftp: "FTPセキュリティー証明書",
        ftpText: "FTPサーバーにアクセスするために必要な証明書です。",
        download: "ダウンロード",
        copy: "クリックしてコピーします。",
        copied: "コピーしました",
        auto: "自動インプレッション",
        autoText:
          "すべてのインプレッションをイベント統合なしで自動的に記録する設定です。この設定をオンにすると、広告応答で返されたすべての製品がサイトに表示されているとみなして、各製品の表示指標が自動的に記録されます。設定をオフにすると、各表示ごとに指定の形式でイベントリクエストを送信する必要があります。",
        link: "インプレッションイベント",
        apiLink: "APIエンドポイント",
      },
      transactions: {
        subtext: "広告主がキャンペーンの費用として使用する残高を設定できます。",
        warning: "請求書番号を追加できます。",
        balance_updated: "残高支払い",
        gift_coupon: "ギフトクーポン",
        welcome_coupon: "ウェルカムクーポン",
        refund: "払い戻し",
        spend: "広告費用",
        ad_balance_loaded_desc: "広告残高を追加しました。",
        spend_desc: "広告費用を使用しました。",
        gift_coupon_desc: "ギフトクーポンを獲得しました。",
        welcome_coupon_desc: "ウェルカムクーポンを獲得しました。",
        ad_balance_refunded_desc: "広告残高が払い戻しされました。",
        credit_card_desc: "クレジットカードで残高が更新されました。",
        detailsSubtext: "広告費用の詳細を確認できます。",
        spendTab: "広告費用",
        budgetTab: "予算項目",
        advertiser_budget: "残高",
        approve: "残高の追加を続行しますか？",
        advertiser: "広告主：",
        balance: "「追加」される残高：",
        update: "請求書番号を追加または編集できます。",
        title: "請求書情報",
        payment: "支払い",
        success: "成功",
        waiting: "待機中",
        failure: "失敗",
        invoiceWarning: "請求書番号を最大30文字まで入力できます。",
        note: "残高アップロードノート",
        noteHelp: "この残高をアップロードする理由を含めます。例：8月の残高",
        coupon_expired: "クーポンの有効期限が切れました",
        coupon_expired_desc: "このクーポンの有効期限が切れました。",
        risk: "この操作は高リスクです！",
        riskDesc:
          "残高を払い戻すと、広告主の日々の支出に影響を与え、マイナス残高になる可能性があります。続行する前に、広告主のすべてのキャンペーンが一時停止されていることを確認してください。",
        refundTitle: "この操作は元に戻せません！",
        refundDescription:
          "指定された金額は即座に広告主の残高から差し引かれます。広告主の日々の支出を確認せずに払い戻しを行うと、マイナス残高になり、問題が発生する可能性があります。",
        selectAdvertiserHelp: "払い戻しを受け取る広告主を選択してください。",
        refundAmount: "金額",
        verifyRefundAmount: "金額を確認",
        refundAmountHelp:
          "正確な払い戻し額を指定してください。この操作は元に戻せないため、注意してください。",
        verifyRefundAmountHelp: "払い戻し金額を確認",
        refundNote: "備考",
        refundNoteHelp:
          "この欄では、払い戻しの理由についてメモを追加できます。追跡や記録の明確化に役立ちます。",
        amountToRefund: "払い戻し金額：",
        check1:
          "広告主が過去 24 時間以内に残高を使用していないことを確認しました。",
        check2:
          "広告主のすべてのキャンペーンが少なくとも 24 時間一時停止されていることを確認しました。",
        check3:
          "この払い戻しが即時に適用され、元に戻せないことを理解しています。",
        check4:
          "この払い戻しがマイナス残高を引き起こした場合、その結果に対して全責任を負うことを認めます。",
        check5:
          "広告主に代わってこの払い戻しを処理するための必要な権限があることを確認します。",
        refundSuccessTitle: "払い戻しが正常に処理されました！",
        refundSuccessText:
          "残高が正常に広告主のアカウントから差し引かれました。問題が発生した場合は、広告主のアカウントアクティビティを再確認するか、サポートにお問い合わせください。",
        refundErrorTitle: "払い戻しに失敗しました",
        refundErrorText:
          "現在、払い戻しを処理できませんでした。予期しない問題が発生した可能性があります。",
        negativeRefundErrorTitle: "返金に失敗しました",
        negativeRefundErrorText:
          "返金額が利用可能な残高を超えています。現在の残高以下の金額を入力してください。",
      },
      users: {
        label: "メール",
        subtext: "招待状の確認メールが送信されます。",
        invite: "招待状が送信されるメールアドレスを入力します。",
        warn: "自分のアカウントを停止することはできません。",
        error: "既存のメールアドレスを追加しました。",
        search: "ユーザー内を検索",
        select: "追加するユーザーのタイプを選択します。",
        advertiser: "広告主",
        advertiserText:
          "選択した広告主アカウントのみがアクセスでき、広告活動を実行する人物です。",
        marketplace: "管理者",
        marketplaceText:
          "広告プラットフォーム内のすべての権限を持ち、ユーザーへのアクセス権を付与または管理できます。",
        limited: "制限付きアクセス",
        full: "フルアクセス",
      },
      invited: {
        error:
          "同じアカウントに対して同じメールアドレスに招待状を送信できるのは、10分に1回までです。",
        success: "ユーザーが再度招待されました。",
        search: "招待されたユーザー内を検索",
        title: "招待状の詳細",
        info: "一般情報",
        mail: "メール：",
        advertiser: "広告主：",
        urlTitle: "招待リンク",
        link: "広告主ユーザーを追加する方法は？",
        single: "シングルユーザー",
        multiple: "一括ユーザー",
        advertiserText: "広告主を選択",
        draggerTitle:
          "<strong>.CSV</strong>ファイルを選択して、一括メールをアップロード",
        draggerText: "またはここにドラッグ＆ドロップします。",
        csvError: "ファイルをアップロード中にエラーが発生しました。",
        csvInfo:
          "CSVファイルを使用して、複数のユーザーを異なる広告主アカウントに一括招待できます。CSVファイルの形式に関する情報は、以下のリンクからアクセスできます。",
        restriction: "制限付きアクセス",
        restrictionText:
          "このオプションをオンにすると、ユーザーにはレポート権限のみが与えられます。",
        edit: "編集",
        role: "役割：",
        MARKETPLACE: "管理者",
        MARKETPLACE_REPORTER: "管理者レポーター",
        ADVERTISER: "広告主",
        ADVERTISER_REPORTER: "広告主レポーター",
      },
      sync: {
        file: "ファイル",
        api: "API",
        feed: "フィード",
        products_created: "製品が作成されました。",
        products_updated: "製品が更新されました。",
        products_deactivated: "製品のアクティブ化が解除されました。",
        products_activated: "製品がアクティブ化されました。",
        missing_advertisers: "広告主が見つかりません。",
        advertisers_created: "広告主が作成されました。",
        advertisers_updated: "広告主が更新されました。",
        advertisers_deactivated: "広告主のアクティブ化が解除されました。",
        advertisers_activated: "広告主がアクティブ化されました。",
        categories_created: "カテゴリーが作成されました。",
      },
      placement: {
        add: "新しい広告配信面を追加",
        display: "ディスプレイ",
        product: "スポンサー製品",
        update: "広告配信面を更新",
        settings: "一般設定",
        settingsText: "広告配信面の一般設定",
        name: "広告配信面名",
        nameText: "この名前は、あなただけが見ることができます。",
        format: "広告形式",
        formatText: "広告配信面が表示される形式",
        sponsoredText: "関連するキーワードおよびカテゴリーにおける製品表示",
        displayText:
          "関連するキーワードおよびカテゴリーにおけるビジュアル広告表示",
        suggestedTitle: "推奨サイズ",
        suggestedText:
          "広告配信面の実際のサイズです。このサイズは広告主に表示されます。",
        suggestedError: "1サイズまで追加可能です。",
        acceptedTitle: "対応可能サイズ",
        acceptedText:
          "広告配信面内に表示される他の広告サイズです。次元は広告主によって表示されます。",
        acceptedError: "広告サイズを選択してください。",
        formatError: "形式を選択してください。",
        cross_sell: "クロスセル",
        crossText:
          "関連する製品詳細ページへの広告表示や、リストされた製品の広告表示が防止されます。",
        maxAds: "広告の最大数",
        maxAdsText: "広告配信面に配置できる広告の最大数です。",
        crossTitle: "広告ブロックの動作",
        crossSub:
          "広告配信面の実際のサイズです。このサイズは広告主に表示されます。",
        crossPlaceholder: "タイプを選択します。",
        crossProduct: "リスト製品のブロック",
        crossBlock: "広告表示をブロック",
        crossError: "動作を選択します。",
        adPlacementType: "広告配置タイプ",
        adPlacementTypeText:
          "広告が表示されるページまたは配置の種類を選択してください。この選択は、作成されたキャンペーンの広告配置ターゲティングフェーズでも使用されます。",
        typeError: "ページの種類を選択してください。",
        adPlacementTypePlaceholder: "ページタイプを選択",
        search: "検索結果",
        category: "カテゴリーのページ",
        homepage: "ホームページ",
        detail: "製品詳細ページ",
        collection: "コレクション",
        minAds: "最小広告数",
        minAdsText: "配置が持つことができる最小の広告数です。",
        minBid: "最低入札額",
        minBidText: "これはこの配置に対する最低入札額です。",
        videoWarning: "ビデオ広告の広告の最大数は <strong>“1”</strong> です。",
        promoteText:
          "製品プロモーションが有効な場合、1つの広告しか追加できません。",
        displayWithProduct: "スポンサーディスプレイ（製品付き）",
        videoWithProduct: "スポンサービデオ（製品付き）",
        display_with_product: "スポンサーディスプレイ（製品付き）",
        video_with_product: "スポンサービデオ（製品付き）",
        archive_confirmation_text:
          "{{name}} をアーカイブすると、アクティブリストから削除され、広告配信から除外されます。",
        archive_checkbox_text: "理解しました。続行します。",
      },
      restrictions: {
        category: "カテゴリー",
        keyword: "キーワード",
        categoryTitle: "カテゴリーごとの入札額とACoS設定",
        categoryText:
          "特定のカテゴリー内のみで有効な最低入札額とターゲットACoSを設定できます。また、カテゴリーの関連性もカスタマイズできます。この設定は一般設定よりも優先されます。",
        keywordText:
          "指定したキーワードでの広告表示を制限できます。［限定］タイプに設定すると、そのキーワードを含む製品だけが検索結果に表示されます。［ブロック］タイプでは、そのキーワードを含む検索結果には広告が表示されません。",
        placeholder: "キーワードを検索",
        add: "新しいキーワードを追加",
        info: "一般情報",
        label: "キーワード",
        help: "検索結果を制限するキーワード",
        type: "制限タイプ",
        typeText: "キーワードを使用した検索結果に適用される制限タイプ",
        exclusive: "限定",
        exclusiveText:
          "検索結果には、キーワードに一致する製品のみが広告として表示されます。",
        block: "ブロック",
        blockText: "すべての広告が検索結果でブロックされています。",
        all: "すべて表示",
        edited: "編集されたカテゴリーを表示",
        expand: "すべて展開",
        collapse: "すべて折りたたむ",
      },
      offsite: {
        connect: "Metaアカウントを接続",
        connectText:
          "Metaアカウントを接続して、オフサイト広告の作成と管理を簡単に始めましょう。",
        loginWithFacebook: "Facebookでログイン",
        success: "Meta に正常に接続しました",
        reauthenticate: "再認証",
        revoke: "アクセスを取り消す",
        adAccount: "広告アカウント",
        adAccountText:
          "Facebook 広告キャンペーンには広告アカウントが必要です。トラッキングピクセルやカスタムオーディエンスなどのオブジェクトは、このアカウントに紐付けられます。これはアカウント資産であり、アカウント設定の一部になります。",
        adAccountPlaceholder: "広告アカウントを選択",
        identity: "アイデンティティ",
        identityText:
          "ユーザーは、広告でビジネスを代表する Facebook または Instagram アカウントを選択する必要があります。これにより、アイデンティティの競合を防ぎ、アカウントレベルで適用されます。",
        facebookPlaceholder: "Facebook ページを選択",
        instagramPlaceholder: "Instagram アカウントを選択",
        pixel: "Meta ピクセル",
        pixelText:
          "販売キャンペーンを開始する前に、Meta ピクセルまたは SDK を統合することが重要です。適切なイベントがトラッキングされ、正しいコンバージョンイベントが設定されていることを確認してください。Meta の標準イベントを使用する場合でも、必ずクライアントのピクセル設定を確認してください。",
        pixelPlaceholder: "ピクセルを選択",
        pendingTitle: "Meta アカウントを接続中",
        pendingText:
          "現在、Meta アカウントを接続しています。アカウント設定や接続手順によっては、このプロセスに時間がかかる場合があります。",
        attribution: "アトリビューション設定",
        attributionText:
          "アトリビューションウィンドウとは、ユーザーが広告を閲覧またはクリックしてからアクションを起こすまでの日数です。通常、同じ設定がキャンペーン全体で使用されるため、アカウントレベルで管理するのが合理的です。",
        none: "なし",
        oneDay: "1日",
        sevenDays: "7日",
        clickThrough: "クリック経由",
        viewThrough: "視聴経由",
        engagedView: "エンゲージドビュー",
        clickThroughPlaceholder: "クリック経由を選択",
        viewThroughPlaceholder: "視聴経由を選択",
        engagedViewPlaceholder: "エンゲージドビューを選択",
        revokeSuccess: "Meta へのアクセスを正常に取り消しました",
        location: "マーケットプレイスの場所",
        locationText: "ビジネスの所在地を選択",
        locationPlaceholder: "所在地を選択",
        multipleAccounts:
          "複数のビジネスアカウントが見つかりました。1つのビジネスアカウントのみを選択してください。",
      },
    },
    auth: {
      title: "{{value}}広告プラットフォーム",
      accounts: {
        title: "アカウントを選択",
        text: "ログインするアカウントを選択します。",
        logout: "ログアウト",
      },
      login: {
        title: "ログイン",
        text: "お帰りなさい。情報を入力してください。",
        remember: "ログイン状態を保持",
        forget: "パスワードを忘れた方",
        button: "ログイン",
        mail: "メール",
        password: "パスワード",
        mailErr: "メールアドレスを入力してください。",
        passwordErr: "パスワードを入力してください。",
        incorrectPassword: "パスワードが間違っています。",
        incorrectPasswordText: "もう一度お試しください。",
        recaptcha: "reCAPTCHA 検証エラー。",
        recaptchaText: "もう一度お試しください。",
        notActive: "アカウントが停止されました。",
        notActiveText: "サポートチームにお問合せください。",
        multipleAccountErr: "新しいアカウントを作成中にエラーが発生しました。",
        notHaveAnAccount: "既存のアカウントをお持ちではない方",
        signup: "サインアップ",
        linkButton: "ログインリンクを送信",
        success: "ログインリンクがあなたのメールに送信されました。",
        successText:
          "受信したメール内のリンクをクリックしてアカウントにログインしてください。",
        error: "ログイン中にエラーが発生しました。",
        errorText: "もう一度お試しください。",
        invalidEmail: "無効なメールアドレスです。",
        invalidEmailText: "有効なメールアドレスを入力してください。",
        userNotFound: "このメールアドレスのユーザーが見つかりません。",
        userNotFoundText: "メールアドレスを確認して再度お試しください。",
        verificationError:
          "リクエストの確認ができませんでした。もう一度お試しください。",
        notFound:
          "ご利用のリンクは、登録されたマーケットプレイスのいずれとも一致しません。",
      },
      signUp: {
        title: "サインアップ",
        text: "{{value}}さん、ようこそ",
        password: "パスワード",
        passwordErr: "パスワードを入力してください。",
        warning:
          "数字、句読点、大文字と小文字を含む少なくとも8文字のパスワードを入力してください。",
        already: "既存のアカウントをお持ちですか？",
        successBtn: "ログイン",
        success: "登録しました。",
        successText:
          "登録が、{{value}}のメールアドレスで完了しました。ログインボタンをクリックして、パネルを開きます。",
        help: "サポートが必要ですか？",
        err: "有効なパスワードを入力してください。",
        userExistErr:
          "このユーザーは既に存在します。アクセス可能なアカウントを表示するには、ログインしてください。",
        privacyErr:
          "サインアップを完了するには、すべての必要な同意書に同意してください。",
        error: "招待状が見つかりません。",
        errorText:
          "登録するには招待が必要です。{{value}}経由でアカウントマネージャーにお問合せください。",
        errorTextNoEmail:
          "登録するには招待が必要です。アカウントマネージャーにお問合せください。",
        errorBtn: "ホームページに戻る",
      },
      password: {
        title: "パスワードを忘れた方",
        text: "パスワードをリセットするリンクをお送りします。プラットフォームで使用するメールアドレスを入力してください。",
        mail: "メール",
        mailInputErr: "メールアドレスを入力してください。",
        reset: "パスワードをリセット",
        return: "ログインページに移動",
        error: "パスワードをリセットしたいメールアドレスを入力してください。",
        recaptchaError:
          "セキュリティ上の理由により、パスワードの再設定試行が失敗しました。ページを更新してもう一度お試しください。",
        check: "メールを確認",
        message: "{{value}}にパスワードリセットリンクを送信しました",
      },
      newPassword: {
        title: "新しいパスワードを設定",
        text: "新しいパスワードは、以前使用したパスワードとは異なる必要があります。",
        help: "数字、句読点、大文字と小文字を含む少なくとも8文字のパスワードを入力してください。",
        password: "パスワード",
        passwordInputErr: "パスワードを入力してください。",
        again: "パスワードを再入力",
        check: "パスワードをリセットしました",
        message: "設定した新しいパスワードでログインできます。",
        errTitle: "有効なパスワードを入力してください。",
      },
      welcome: {
        title: "ようこそ。",
        loginText:
          "アカウントをお持ちの場合は、ログインボタンをクリックして情報を入力できます。",
        loginBtn: "ログイン",
        signupText:
          "アカウントをお持ちでない場合は、以下のボタンをクリックして登録し、パスワードを設定してからアカウントにログインできます。",
        signupBtn: "サインアップ",
      },
    },
  },
  common: {
    save: "保存",
    selectAll: "すべて選択",
    search: "検索",
    edit: "編集",
    export: "エクスポート",
    remove: "削除",
    add: "追加",
    column: "列",
    archive: "アーカイブ",
    removeArchive: "アーカイブ解除",
    delete: "削除",
    filter: "フィルター",
    continue: "続行",
    cancel: "キャンセル",
    cancellation: "キャンセル",
    okay: "OK",
    create: "作成",
    goBack: "戻る",
    listed: "リスト済み",
    archived: "アーカイブ済み",
    invited: "招待者",
    exact: "完全一致",
    phrase: "フレーズ一致",
    broad: "広範一致",
    turkey: "トルコ",
    abd: "アメリカ",
    try: "トルコリラ",
    usd: "米ドル",
    iqd: "イラクディナール",
    twd: "台湾ドル",
    hkd: "香港ドル",
    krw: "韓国ウォン",
    jpy: "日本円",
    zone: "ヨーロッパ/イスタンブール",
    clear: "クリア",
    clearAll: "すべてクリア",
    completed: "完了済み",
    notCompleted: "未完了",
    now: "今",
    checkAll: "すべて選択",
    keyword: "キーワード",
    negative: "ネガティブキーワード",
    tr: "トルコ語",
    en: "英語",
    day: "日",
    invite: "招待",
    accept: "承認",
    reject: "拒否",
    pageTotal: "「表示」する行数：",
    addUser: "ユーザーを追加",
    reinvite: "再招待",
    advertiser: "広告主",
    admin: "管理者",
    new_customer: "新規顧客",
    existing_customer: "既存の顧客",
    category_buyer: "カテゴリー購入者",
    invite_url: "招待リンクを表示",
    copy: "コピーを作成",
    or: "または",
    exit: "出口",
    docs: "統合と広告配信に関する情報については、API ドキュメントをご覧ください！",
    apply: "適用",
    reset: "リセット",
    read: "既読としてマーク",
    unread: "未読としてマーク",
    view: "表示",
    onAndOff: "オン/オフ",
    hasError: "問題が発生しました",
    refresh: "ページを更新",
    days: {
      monday: "月曜日",
      tuesday: "火曜日",
      wednesday: "水曜日",
      thursday: "木曜日",
      friday: "金曜日",
      saturday: "土曜日",
      sunday: "日曜日",
    },
    languages: {
      arabic: "アラビア語",
      english: "英語",
    },
    table: {
      name: "名前",
      status: "アクティブ",
      state: "ステータス",
      agency_name: "代理店",
      type: "タイプ",
      resource_id: "販売者ID",
      last_login: "最終ログイン日",
      balance: "残高",
      sum_coupons_amount: "クーポン",
      total_balance: "総残高",
      impressions: "インプレッション",
      viewable_impressions: "表示可能なインプレッション",
      clicks: "クリック",
      CTR: "CTR",
      spend: "広告費",
      sale_amount: "販売額",
      direct_sale_amount: "直接販売額",
      indirect_sale_amount: "間接販売額",
      sale: "販売",
      direct_sale: "直接販売",
      indirect_sale: "間接販売",
      ACoS: "ACoS",
      CVR: "CVR",
      campaign_name: "名前",
      advertiser_name: "広告主",
      ad_type: "広告タイプ",
      start_date: "開始日",
      end_date: "終了日",
      budget_type: "予算",
      bid_type: "入札タイプ",
      fixed_bid: "入札",
      custom_key: "ID",
      ad_format: "広告形式",
      max_ads: "最大広告数",
      recommended_size: "推奨サイズ",
      sizes: "サイズ",
      image_url: "クリエイティブ",
      policy_status: "ステータス",
      transaction_date: "日付",
      invoice_number: "請求書番号",
      transaction_type: "取引タイプ",
      description: "説明",
      created_by: "作成者",
      amount: "金額",
      spend_details: "詳細",
      note: "注意",
      expire_date: "有効期限",
      account_user_status: "アクティブ",
      user_email: "メール",
      account_user_role: "認証",
      user_last_login: "最終ログイン日",
      account_user_created_at: "作成日",
      email: "メール",
      account_role: "認証",
      created_at: "招待日",
      report_name: "名前",
      report_start_date: "開始日",
      report_end_date: "終了日",
      report_type: "レポートタイプ",
      report_delivery_frequency: "頻度",
      report_created_at: "作成日",
      text: "名前",
      minimum_bid: "最低CPC",
      minimum_cpm: "最低CPM",
      relevance: "関連性",
      restriction_type: "制限タイプ",
      row_count: "行数",
      message: "操作メッセージ",
      sync_type: "同期タイプ",
      file_name: "ファイル名",
      product: "製品",
      sku: "SKU",
      buybox: "Buy Box",
      city: "都市",
      age_range: "年齢",
      gender: "性別",
      platform: "プラットフォーム",
      customer: "顧客",
      category: "カテゴリー",
      keyword: "キーワード",
      match_type: "一致タイプ",
      bid: "入札",
      category_volume: "インプレッション数",
      active: "アクティブ",
      paused: "一時停止中",
      invited: "招待済み",
      uninvited: "未招待",
      archived: "アーカイブ済み",
      on: "アクティブ",
      stopped: "一時停止中",
      open: "開く",
      closed: "閉じる",
      coupon: "クーポン",
      sync_log_created_at: "日付",
      category_text: "カテゴリー",
      keyword_text: "キーワード",
      creative_name: "名前",
      invoice: "請求書番号",
      acos: "ACoS",
      sum_click: "クリック数",
      sum_direct_sale: "直接販売",
      sum_direct_sale_amount: "直接販売額",
      sum_impression: "インプレッション数",
      sum_sale: "販売",
      sum_sale_amount: "販売額",
      sum_spend: "支出",
      spending_type: "支出分配",
      min_ads: "最小広告数",
      min_bid: "最小入札額",
      languages: "言語",
      video_start: "動画開始数",
      video_complete: "動画完了数",
      VCR: "動画完了率",
      entity: "エンティティ",
      import_method: "インポート方法",
      schedule_interval: "サイクル",
      finish_date: "終了日",
      id: "ID",
      uuid: "UUID",
      updated_by: "更新者",
      objective: "目的",
      daily_budget: "日予算",
      reach: "リーチ",
      frequency: "頻度",
      link_click: "リンククリック",
      meta_created_at: "作成日",
      ACTIVE: "アクティブ",
      PAUSED: "一時停止",
      DELETED: "削除済み",
      ARCHIVED: "アーカイブ済み",
      FAILED: "失敗",
      PENDING: "保留中",
      price: "価格",
      stock: "在庫",
      rating: "評価",
      barcode: "バーコード",
    },
    equality: {
      contains: "含む",
      not_contains: "含まない",
      equal: "等しい",
      not_equal: "等しくない",
      less_than: "未満",
      grater_than: "より大きい",
      greater_or: "以上",
      less_or: "以下",
      any_of: "いずれか",
      none_of: "いずれでもない",
    },
    filters: {
      campaignName: "名前",
      campaignStartDate: "開始日",
      campaignEndDate: "終了日",
      campaignStatus: "アクティブ",
      campaignState: "ステータス",
      campaignBudget: "予算",
      campaignBudgetType: "予算タイプ",
      campaignBidType: "入札タイプ",
      campaignMaxAcos: "最大ACoS",
      campaignFixedBid: "固定入札",
      campaignAdType: "広告タイプ",
      sumSale: "販売",
      sumSpend: "支出",
      ACoS: "ACoS",
      productName: "製品",
      productCampaignStatus: "ステータス",
      sumClick: "クリック",
      CVR: "CVR",
      keywordCampaignStatus: "ステータス",
      keywordText: "キーワード",
      keywordMatchType: "一致タイプ",
      negativeKeywordCampaignStatus: "ステータス",
      negativeKeywordText: "ネガティブキーワード",
      negativeKeywordMatchType: "一致タイプ",
      cityName: "都市",
      cityCampaignStatus: "ステータス",
      ageRangeText: "年齢",
      ageRangeCampaignStatus: "ステータス",
      genderText: "性別",
      genderCampaignStatus: "ステータス",
      platformText: "プラットフォーム",
      platformCampaignStatus: "ステータス",
      customerTargetingText: "顧客",
      customerTargetingCampaignStatus: "ステータス",
      placementText: "広告配信面",
      placementCampaignStatus: "ステータス",
      reportName: "レポート名",
      reportStartDate: "開始日",
      reportEndDate: "終了日",
      reportType: "レポートタイプ",
      reportDeliveryFrequency: "頻度",
      reportCreatedAt: "作成日",
      agencyName: "代理店名",
      advertiserName: "広告主",
      advertiserStatus: "広告主のステータス",
      sumSaleAmount: "販売額",
      sumDirectSale: "直接販売",
      sumIndirectSale: "間接販売",
      sumDirectSaleAmount: "直接販売額",
      sumIndirectSaleAmount: "間接販売額",
      sumImpression: "インプレッション数",
      productBrand: "製品ブランド",
      CTR: "CTR",
      categoryName: "カテゴリー",
      advertiserId: "広告主ID",
      agencyId: "代理店ID",
      name: "製品名",
      brand: "ブランド",
      retailer_taxonomy: "製品カテゴリー",
      advertiser_id: "広告主ID",
      transaction_type: "取引タイプ",
      advertiser_name: "広告主",
      created_by: "作成者",
      campaignDailyBudget: "1日の予算",
      campaignTotalBudget: "総予算",
      campaignId: "キャンペーン ID",
    },
    equalityValues: {
      ct: "含む",
      nc: "含まない",
      eq: "等しい",
      ne: "等しくない",
      in: "いずれか",
      ni: "いずれでもない",
      notin: "いずれでもない",
      lt: "未満",
      gt: "より大きい",
      ge: "以上",
      le: "以下",
    },
    values: {
      ACTIVE: "アクティブ",
      PAUSED: "一時停止中",
      DAILY: "毎日",
      TOTAL: "合計",
      STANDART: "自動",
      FIXED: "固定",
      MAX_ACOS: "最大ACoS",
      WEEKLY: "毎週",
      MONTHLY: "毎月",
      EXACT: "完全一致",
      PHRASE: "フレーズ一致",
      BROAD: "広範一致",
      BALANCE_UPDATED: "残高支払い",
      GIFT_COUPON: "ギフトクーポン",
      WELCOME_COUPON: "ウェルカムクーポン",
      SPEND: "広告費用",
      NOT_STARTED: "キャンペーンはまだ開始されていません。",
      DATE_PASSED: "キャンペーンが、スケジュール終了日を過ぎました。",
      STATUS_PAUSED: "キャンペーンを一時停止しました。",
      OUT_OF_DAILY_BUDGET: "キャンペーンの1日の予算がすべて使われました。",
      OUT_OF_TOTAL_BUDGET: "キャンペーンの総予算上限に達しました。",
      PRODUCTS_STOPPED: "製品がアクティブではありません。",
      KEYWORDS_STOPPED: "キーワードがアクティブではありません。",
      CATEGORIES_STOPPED: "カテゴリーがアクティブではありません。",
      STATUS_ARCHIVED: "キャンペーンをアーカイブしました。",
      CREATIVES_STOPPED: "アクティブなクリエイティブがありません。",
      INSUFFICIENT_BALANCE: "残高が不足しています。",
      LOW_BID: "入札額が最低入札額を下回っています。",
      REGIONS_STOPPED: "地域がアクティブではありません。",
      PRODUCT: "スポンサー製品",
      BRAND: "スポンサーブランド",
      DISPLAY: "スポンサーディスプレイ",
      STORE: "スポンサーストア",
      VIDEO: "スポンサービデオ",
      DISPLAY_WITH_PRODUCT: "スポンサーディスプレイ（製品付き）",
      VIDEO_WITH_PRODUCT: "スポンサービデオ（製品付き）",
    },
    month: {
      may: "5月",
      june: "6月",
      september: "9月",
      october: "10月",
      december: "12月",
    },
  },
};

export default jp;
